(function (root, factory) {
  if (typeof define === 'function' && define.amd)
    define(['exports', './kotlin_kotlin.js', './kotlin_org_jetbrains_kotlinx_atomicfu.js'], factory);
  else if (typeof exports === 'object')
    factory(module.exports, require('./kotlin_kotlin.js'), require('./kotlin_org_jetbrains_kotlinx_atomicfu.js'));
  else {
    if (typeof kotlin_kotlin === 'undefined') {
      throw new Error("Error loading module 'kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core'. Its dependency 'kotlin_kotlin' was not found. Please, check whether 'kotlin_kotlin' is loaded prior to 'kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core'.");
    }
    if (typeof kotlin_org_jetbrains_kotlinx_atomicfu === 'undefined') {
      throw new Error("Error loading module 'kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core'. Its dependency 'kotlin_org_jetbrains_kotlinx_atomicfu' was not found. Please, check whether 'kotlin_org_jetbrains_kotlinx_atomicfu' is loaded prior to 'kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core'.");
    }
    root.kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core = factory(typeof kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core === 'undefined' ? {} : kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core, kotlin_kotlin, kotlin_org_jetbrains_kotlinx_atomicfu);
  }
}(this, function (_, kotlin_kotlin, kotlin_org_jetbrains_kotlinx_atomicfu) {
  //region block: imports
  var imul = Math.imul;
  var THROW_CCE = kotlin_kotlin.$crossModule$.THROW_CCE;
  var isObject = kotlin_kotlin.$crossModule$.isObject;
  var Unit_getInstance = kotlin_kotlin.$crossModule$.Unit_getInstance;
  var plus = kotlin_kotlin.$crossModule$.plus;
  var get = kotlin_kotlin.$crossModule$.get_1;
  var fold = kotlin_kotlin.$crossModule$.fold;
  var minusKey = kotlin_kotlin.$crossModule$.minusKey_1;
  var Continuation = kotlin_kotlin.$crossModule$.Continuation;
  var createCoroutineUnintercepted = kotlin_kotlin.$crossModule$.createCoroutineUnintercepted;
  var atomic$boolean$1 = kotlin_org_jetbrains_kotlinx_atomicfu.$crossModule$.atomic$boolean$1;
  var Result__exceptionOrNull_impl_1523290257 = kotlin_kotlin.$crossModule$.Result__exceptionOrNull_impl_1523290257;
  var _Result___get_value__impl__3597185688 = kotlin_kotlin.$crossModule$._Result___get_value__impl__3597185688;
  var toString = kotlin_kotlin.$crossModule$.toString_1;
  var hashCode = kotlin_kotlin.$crossModule$.hashCode;
  var equals = kotlin_kotlin.$crossModule$.equals;
  var AbstractCoroutineContextKey = kotlin_kotlin.$crossModule$.AbstractCoroutineContextKey;
  var Key_getInstance = kotlin_kotlin.$crossModule$.Key_getInstance;
  var AbstractCoroutineContextElement = kotlin_kotlin.$crossModule$.AbstractCoroutineContextElement;
  var get_0 = kotlin_kotlin.$crossModule$.get;
  var minusKey_0 = kotlin_kotlin.$crossModule$.minusKey;
  var ContinuationInterceptor = kotlin_kotlin.$crossModule$.ContinuationInterceptor;
  var Key = kotlin_kotlin.$crossModule$.Key;
  var RuntimeException_init_$Create$ = kotlin_kotlin.$crossModule$.RuntimeException_init_$Create$;
  var EmptyCoroutineContext_getInstance = kotlin_kotlin.$crossModule$.EmptyCoroutineContext_getInstance;
  var Enum = kotlin_kotlin.$crossModule$.Enum;
  var startCoroutine = kotlin_kotlin.$crossModule$.startCoroutine;
  var noWhenBranchMatchedException = kotlin_kotlin.$crossModule$.noWhenBranchMatchedException;
  var Long = kotlin_kotlin.$crossModule$.Long;
  var RuntimeException = kotlin_kotlin.$crossModule$.RuntimeException;
  var RuntimeException_init_$Init$ = kotlin_kotlin.$crossModule$.RuntimeException_init_$Init$;
  var captureStack = kotlin_kotlin.$crossModule$.captureStack;
  var Error_0 = kotlin_kotlin.$crossModule$.Error;
  var Error_init_$Init$ = kotlin_kotlin.$crossModule$.Error_init_$Init$;
  var Element = kotlin_kotlin.$crossModule$.Element;
  var StringBuilder_init_$Create$ = kotlin_kotlin.$crossModule$.StringBuilder_init_$Create$;
  var anyToString = kotlin_kotlin.$crossModule$.anyToString;
  var throwUninitializedPropertyAccessException = kotlin_kotlin.$crossModule$.throwUninitializedPropertyAccessException;
  var ArrayList_init_$Create$ = kotlin_kotlin.$crossModule$.ArrayList_init_$Create$;
  var CancellationException = kotlin_kotlin.$crossModule$.CancellationException;
  var isInterface = kotlin_kotlin.$crossModule$.isInterface;
  var toString_0 = kotlin_kotlin.$crossModule$.toString;
  var IllegalStateException_init_$Create$ = kotlin_kotlin.$crossModule$.IllegalStateException_init_$Create$;
  var atomic$ref$1 = kotlin_org_jetbrains_kotlinx_atomicfu.$crossModule$.atomic$ref$1;
  var ArrayList = kotlin_kotlin.$crossModule$.ArrayList;
  var IllegalStateException_init_$Create$_0 = kotlin_kotlin.$crossModule$.IllegalStateException_init_$Create$_1;
  var atomic$int$1 = kotlin_org_jetbrains_kotlinx_atomicfu.$crossModule$.atomic$int$1;
  var UnsupportedOperationException = kotlin_kotlin.$crossModule$.UnsupportedOperationException;
  var UnsupportedOperationException_init_$Create$ = kotlin_kotlin.$crossModule$.UnsupportedOperationException_init_$Create$;
  var fillArrayVal = kotlin_kotlin.$crossModule$.fillArrayVal;
  var arrayCopy = kotlin_kotlin.$crossModule$.arrayCopy;
  var Companion_getInstance = kotlin_kotlin.$crossModule$.Companion_getInstance;
  var createFailure = kotlin_kotlin.$crossModule$.createFailure;
  var _Result___init__impl__2241242780 = kotlin_kotlin.$crossModule$._Result___init__impl__2241242780;
  var ensureNotNull = kotlin_kotlin.$crossModule$.ensureNotNull;
  var intercepted = kotlin_kotlin.$crossModule$.intercepted;
  var _get_COROUTINE_SUSPENDED__2870145053 = kotlin_kotlin.$crossModule$._get_COROUTINE_SUSPENDED__2870145053;
  var getKClassFromExpression = kotlin_kotlin.$crossModule$.getKClassFromExpression;
  var CancellationException_init_$Init$ = kotlin_kotlin.$crossModule$.CancellationException_init_$Init$;
  var getStringHashCode = kotlin_kotlin.$crossModule$.getStringHashCode;
  var HashSet_init_$Create$ = kotlin_kotlin.$crossModule$.HashSet_init_$Create$;
  //endregion
  'use strict';
  //region block: pre-declaration
  function invokeOnCompletion$default(onCancelling, invokeImmediately, handler, $mask0, $handler) {
    if (!(($mask0 & 1) === 0))
      onCancelling = false;
    if (!(($mask0 & 2) === 0))
      invokeImmediately = true;
    return $handler == null ? this.invokeOnCompletion_npwpyn_k$(onCancelling, invokeImmediately, handler) : $handler(onCancelling, invokeImmediately, handler);
  }
  AbstractCoroutine.prototype = Object.create(JobSupport.prototype);
  AbstractCoroutine.prototype.constructor = AbstractCoroutine;
  DeferredCoroutine.prototype = Object.create(AbstractCoroutine.prototype);
  DeferredCoroutine.prototype.constructor = DeferredCoroutine;
  LazyDeferredCoroutine.prototype = Object.create(DeferredCoroutine.prototype);
  LazyDeferredCoroutine.prototype.constructor = LazyDeferredCoroutine;
  DispatchedTask.prototype = Object.create(SchedulerTask.prototype);
  DispatchedTask.prototype.constructor = DispatchedTask;
  CancellableContinuationImpl.prototype = Object.create(DispatchedTask.prototype);
  CancellableContinuationImpl.prototype.constructor = CancellableContinuationImpl;
  Key_0.prototype = Object.create(AbstractCoroutineContextKey.prototype);
  Key_0.prototype.constructor = Key_0;
  CoroutineDispatcher.prototype = Object.create(AbstractCoroutineContextElement.prototype);
  CoroutineDispatcher.prototype.constructor = CoroutineDispatcher;
  CoroutineStart.prototype = Object.create(Enum.prototype);
  CoroutineStart.prototype.constructor = CoroutineStart;
  EventLoop.prototype = Object.create(CoroutineDispatcher.prototype);
  EventLoop.prototype.constructor = EventLoop;
  CompletionHandlerException.prototype = Object.create(RuntimeException.prototype);
  CompletionHandlerException.prototype.constructor = CompletionHandlerException;
  CoroutinesInternalError.prototype = Object.create(Error_0.prototype);
  CoroutinesInternalError.prototype.constructor = CoroutinesInternalError;
  LinkedListHead.prototype = Object.create(LinkedListNode.prototype);
  LinkedListHead.prototype.constructor = LinkedListHead;
  NodeList.prototype = Object.create(LinkedListHead.prototype);
  NodeList.prototype.constructor = NodeList;
  CompletionHandlerBase.prototype = Object.create(LinkedListNode.prototype);
  CompletionHandlerBase.prototype.constructor = CompletionHandlerBase;
  JobNode.prototype = Object.create(CompletionHandlerBase.prototype);
  JobNode.prototype.constructor = JobNode;
  ChildCompletion.prototype = Object.create(JobNode.prototype);
  ChildCompletion.prototype.constructor = ChildCompletion;
  JobCancellingNode.prototype = Object.create(JobNode.prototype);
  JobCancellingNode.prototype.constructor = JobCancellingNode;
  ChildHandleNode.prototype = Object.create(JobCancellingNode.prototype);
  ChildHandleNode.prototype.constructor = ChildHandleNode;
  InvokeOnCancelling.prototype = Object.create(JobCancellingNode.prototype);
  InvokeOnCancelling.prototype.constructor = InvokeOnCancelling;
  InvokeOnCompletion.prototype = Object.create(JobNode.prototype);
  InvokeOnCompletion.prototype.constructor = InvokeOnCompletion;
  MainCoroutineDispatcher.prototype = Object.create(CoroutineDispatcher.prototype);
  MainCoroutineDispatcher.prototype.constructor = MainCoroutineDispatcher;
  TimeoutCancellationException.prototype = Object.create(CancellationException.prototype);
  TimeoutCancellationException.prototype.constructor = TimeoutCancellationException;
  Unconfined.prototype = Object.create(CoroutineDispatcher.prototype);
  Unconfined.prototype.constructor = Unconfined;
  DispatchedContinuation.prototype = Object.create(DispatchedTask.prototype);
  DispatchedContinuation.prototype.constructor = DispatchedContinuation;
  JsMainDispatcher.prototype = Object.create(MainCoroutineDispatcher.prototype);
  JsMainDispatcher.prototype.constructor = JsMainDispatcher;
  UnconfinedEventLoop.prototype = Object.create(EventLoop.prototype);
  UnconfinedEventLoop.prototype.constructor = UnconfinedEventLoop;
  JobCancellationException.prototype = Object.create(CancellationException.prototype);
  JobCancellationException.prototype.constructor = JobCancellationException;
  SetTimeoutBasedDispatcher.prototype = Object.create(CoroutineDispatcher.prototype);
  SetTimeoutBasedDispatcher.prototype.constructor = SetTimeoutBasedDispatcher;
  NodeDispatcher.prototype = Object.create(SetTimeoutBasedDispatcher.prototype);
  NodeDispatcher.prototype.constructor = NodeDispatcher;
  SetTimeoutDispatcher.prototype = Object.create(SetTimeoutBasedDispatcher.prototype);
  SetTimeoutDispatcher.prototype.constructor = SetTimeoutDispatcher;
  MessageQueue.prototype = Object.create(ArrayQueue.prototype);
  MessageQueue.prototype.constructor = MessageQueue;
  ScheduledMessageQueue.prototype = Object.create(MessageQueue.prototype);
  ScheduledMessageQueue.prototype.constructor = ScheduledMessageQueue;
  WindowDispatcher.prototype = Object.create(CoroutineDispatcher.prototype);
  WindowDispatcher.prototype.constructor = WindowDispatcher;
  WindowMessageQueue.prototype = Object.create(MessageQueue.prototype);
  WindowMessageQueue.prototype.constructor = WindowMessageQueue;
  //endregion
  function AbstractCoroutine(parentContext, initParentJob, active) {
    JobSupport.call(this, active);
    if (initParentJob)
      this.initParentJob_4c2lht_k$(parentContext.get_1pi7hg_k$(Key_getInstance_2()));
    this.context_1 = parentContext.plus_rgw9wi_k$(this);
  }
  AbstractCoroutine.prototype._get_context__1558698818_ps0bpe_k$ = function () {
    return this.context_1;
  };
  AbstractCoroutine.prototype._get_coroutineContext__2519429620_td3xn0_k$ = function () {
    return this.context_1;
  };
  AbstractCoroutine.prototype._get_isActive__4035225851_4an5s5_k$ = function () {
    return JobSupport.prototype._get_isActive__4035225851_4an5s5_k$.call(this);
  };
  AbstractCoroutine.prototype.onCompleted_wmtzyo_k$ = function (value) {
  };
  AbstractCoroutine.prototype.onCancelled_oqqex5_k$ = function (cause, handled) {
  };
  AbstractCoroutine.prototype.cancellationExceptionMessage_a64063_k$ = function () {
    return _get_classSimpleName__3937513404(this) + ' was cancelled';
  };
  AbstractCoroutine.prototype.onCompletionInternal_39c1g8_k$ = function (state) {
    if (state instanceof CompletedExceptionally)
      this.onCancelled_oqqex5_k$(state._get_cause__3139734664_j3sn7c_k$(), state._get_handled__2128079701_z704t1_k$());
    else {
      {
        this.onCompleted_wmtzyo_k$((state == null ? true : isObject(state)) ? state : THROW_CCE());
      }
    }
  };
  AbstractCoroutine.prototype.resumeWith_s3a3yh_k$ = function (result) {
    var state = this.makeCompletingOnce_b13xy2_k$(toState$default(result, null, 1, null));
    if (state === _get_COMPLETING_WAITING_CHILDREN__621847959())
      return Unit_getInstance();
    this.afterResume_ufx9w9_k$(state);
  };
  AbstractCoroutine.prototype.afterResume_ufx9w9_k$ = function (state) {
    return this.afterCompletion_2ogq6g_k$(state);
  };
  AbstractCoroutine.prototype.handleOnCompletionException_o179kb_k$ = function (exception) {
    handleCoroutineException(this.context_1, exception);
  };
  AbstractCoroutine.prototype.nameString_cd9e9w_k$ = function () {
    var tmp0_elvis_lhs = _get_coroutineName__3134708654(this.context_1);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return JobSupport.prototype.nameString_cd9e9w_k$.call(this);
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var coroutineName = tmp;
    return '"' + coroutineName + '":' + JobSupport.prototype.nameString_cd9e9w_k$.call(this);
  };
  AbstractCoroutine.prototype.start_1ln6k9_k$ = function (start, receiver, block) {
    start.invoke_wxhu2x_k$(block, receiver, this);
  };
  AbstractCoroutine.$metadata$ = {
    simpleName: 'AbstractCoroutine',
    kind: 'class',
    interfaces: [Job, Continuation, CoroutineScope]
  };
  function async(_this__1828080292, context, start, block) {
    var newContext = newCoroutineContext(_this__1828080292, context);
    var coroutine = start._get_isLazy__54527757_wgpvx_k$() ? new LazyDeferredCoroutine(newContext, block) : new DeferredCoroutine(newContext, true);
    coroutine.start_1ln6k9_k$(start, coroutine, block);
    return coroutine;
  }
  function DeferredCoroutine(parentContext, active) {
    AbstractCoroutine.call(this, parentContext, true, active);
  }
  DeferredCoroutine.prototype.getCompleted_nczk2z_k$ = function () {
    var tmp = this.getCompletedInternal_26f4i6_k$();
    return (tmp == null ? true : isObject(tmp)) ? tmp : THROW_CCE();
  };
  DeferredCoroutine.$metadata$ = {
    simpleName: 'DeferredCoroutine',
    kind: 'class',
    interfaces: [Deferred, SelectClause1]
  };
  function LazyDeferredCoroutine(parentContext, block) {
    DeferredCoroutine.call(this, parentContext, false);
    this.continuation_1 = createCoroutineUnintercepted(block, this, this);
  }
  LazyDeferredCoroutine.prototype.onStart_qth026_k$ = function () {
    startCoroutineCancellable_0(this.continuation_1, this);
  };
  LazyDeferredCoroutine.$metadata$ = {
    simpleName: 'LazyDeferredCoroutine',
    kind: 'class',
    interfaces: []
  };
  function CancellableContinuation() {
  }
  CancellableContinuation.$metadata$ = {
    simpleName: 'CancellableContinuation',
    kind: 'interface',
    interfaces: [Continuation]
  };
  function CancellableContinuationImpl() {
  }
  CancellableContinuationImpl.prototype.detachChild_qdtbew_k$ = function () {
    var tmp0_elvis_lhs = this.parentHandle_1;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return Unit_getInstance();
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var handle = tmp;
    handle.dispose_3n44we_k$();
    this.parentHandle_1 = NonDisposableHandle_getInstance();
  };
  CancellableContinuationImpl.$metadata$ = {
    simpleName: 'CancellableContinuationImpl',
    kind: 'class',
    interfaces: [CancellableContinuation, CoroutineStackFrame]
  };
  function CompletedExceptionally_init_$Init$(cause, handled, $mask0, $marker, $this) {
    if (!(($mask0 & 2) === 0))
      handled = false;
    CompletedExceptionally.call($this, cause, handled);
    return $this;
  }
  function CompletedExceptionally_init_$Create$(cause, handled, $mask0, $marker) {
    return CompletedExceptionally_init_$Init$(cause, handled, $mask0, $marker, Object.create(CompletedExceptionally.prototype));
  }
  function CompletedExceptionally(cause, handled) {
    this.cause_1 = cause;
    this._handled_1 = atomic$boolean$1(handled);
  }
  CompletedExceptionally.prototype._get_cause__3139734664_j3sn7c_k$ = function () {
    return this.cause_1;
  };
  CompletedExceptionally.prototype._get_handled__2128079701_z704t1_k$ = function () {
    return this._handled_1._get_value__3683422336_a43j40_k$();
  };
  CompletedExceptionally.prototype.makeHandled_ws9oq6_k$ = function () {
    return this._handled_1.atomicfu$compareAndSet(false, true);
  };
  CompletedExceptionally.prototype.toString = function () {
    return _get_classSimpleName__3937513404(this) + '[' + this.cause_1 + ']';
  };
  CompletedExceptionally.$metadata$ = {
    simpleName: 'CompletedExceptionally',
    kind: 'class',
    interfaces: []
  };
  function toState(_this__1828080292, onCancellation) {
    var tmp$ret$2;
    $l$block_1: {
      {
      }
      var exception_1 = Result__exceptionOrNull_impl_1523290257(_this__1828080292);
      var tmp;
      if (exception_1 == null) {
        var tmp$ret$0;
        $l$block: {
          var tmp_0 = _Result___get_value__impl__3597185688(_this__1828080292);
          var tmp0__anonymous__2_2495602522 = (tmp_0 == null ? true : isObject(tmp_0)) ? tmp_0 : THROW_CCE();
          tmp$ret$0 = !(onCancellation == null) ? new CompletedWithCancellation(tmp0__anonymous__2_2495602522, onCancellation) : tmp0__anonymous__2_2495602522;
          break $l$block;
        }
        tmp = tmp$ret$0;
      } else {
        var tmp$ret$1;
        $l$block_0: {
          tmp$ret$1 = CompletedExceptionally_init_$Create$(exception_1, false, 2, null);
          break $l$block_0;
        }
        tmp = tmp$ret$1;
      }
      tmp$ret$2 = tmp;
      break $l$block_1;
    }
    return tmp$ret$2;
  }
  function toState$default(_this__1828080292, onCancellation, $mask0, $handler) {
    if (!(($mask0 & 1) === 0))
      onCancellation = null;
    return toState(_this__1828080292, onCancellation);
  }
  function CompletedWithCancellation(result, onCancellation) {
    this.result_1 = result;
    this.onCancellation_1 = onCancellation;
  }
  CompletedWithCancellation.prototype._get_onCancellation__3868581321_71uxiv_k$ = function () {
    return this.onCancellation_1;
  };
  CompletedWithCancellation.prototype.toString = function () {
    return 'CompletedWithCancellation(result=' + toString(this.result_1) + ', onCancellation=' + this.onCancellation_1 + ')';
  };
  CompletedWithCancellation.prototype.hashCode = function () {
    var result = this.result_1 == null ? 0 : hashCode(this.result_1);
    result = imul(result, 31) + hashCode(this.onCancellation_1) | 0;
    return result;
  };
  CompletedWithCancellation.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof CompletedWithCancellation))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof CompletedWithCancellation ? other : THROW_CCE();
    if (!equals(this.result_1, tmp0_other_with_cast.result_1))
      return false;
    if (!equals(this.onCancellation_1, tmp0_other_with_cast.onCancellation_1))
      return false;
    return true;
  };
  CompletedWithCancellation.$metadata$ = {
    simpleName: 'CompletedWithCancellation',
    kind: 'class',
    interfaces: []
  };
  function CoroutineDispatcher$Key$_init_$lambda_3655722671() {
    return function (it) {
      return it instanceof CoroutineDispatcher ? it : null;
    };
  }
  function Key_0() {
    Key_instance = this;
    var tmp = Key_getInstance();
    AbstractCoroutineContextKey.call(this, tmp, CoroutineDispatcher$Key$_init_$lambda_3655722671());
  }
  Key_0.$metadata$ = {
    simpleName: 'Key',
    kind: 'object',
    interfaces: []
  };
  var Key_instance;
  function Key_getInstance_0() {
    if (Key_instance == null)
      new Key_0();
    return Key_instance;
  }
  function CoroutineDispatcher() {
    Key_getInstance_0();
    AbstractCoroutineContextElement.call(this, Key_getInstance());
  }
  CoroutineDispatcher.prototype.isDispatchNeeded_fmz9vn_k$ = function (context) {
    return true;
  };
  CoroutineDispatcher.prototype.interceptContinuation_pbrjat_k$ = function (continuation) {
    return new DispatchedContinuation(this, continuation);
  };
  CoroutineDispatcher.prototype.releaseInterceptedContinuation_4i98ok_k$ = function (continuation) {
    var dispatched = continuation instanceof DispatchedContinuation ? continuation : THROW_CCE();
    dispatched.release_wtm6d2_k$();
  };
  CoroutineDispatcher.prototype.toString = function () {
    return _get_classSimpleName__3937513404(this) + '@' + _get_hexAddress__2831015762(this);
  };
  CoroutineDispatcher.$metadata$ = {
    simpleName: 'CoroutineDispatcher',
    kind: 'class',
    interfaces: [ContinuationInterceptor]
  };
  function handleCoroutineException(context, exception) {
    try {
      var tmp0_safe_receiver = context.get_1pi7hg_k$(Key_getInstance_1());
      if (tmp0_safe_receiver == null)
        null;
      else {
        var tmp$ret$0;
        {
          {
          }
          tmp0_safe_receiver.handleException_w1h9is_k$(context, exception);
          return Unit_getInstance();
        }
      }
      Unit_getInstance();
    } catch ($p) {
      if ($p instanceof Error) {
        handleCoroutineExceptionImpl(context, handlerException(exception, $p));
        return Unit_getInstance();
      } else {
        {
          throw $p;
        }
      }
    }
    handleCoroutineExceptionImpl(context, exception);
  }
  function Key_1() {
    Key_instance_0 = this;
  }
  Key_1.$metadata$ = {
    simpleName: 'Key',
    kind: 'object',
    interfaces: [Key]
  };
  var Key_instance_0;
  function Key_getInstance_1() {
    if (Key_instance_0 == null)
      new Key_1();
    return Key_instance_0;
  }
  function handlerException(originalException, thrownException) {
    if (originalException === thrownException)
      return originalException;
    var tmp$ret$0;
    $l$block: {
      var tmp0_apply_0 = RuntimeException_init_$Create$('Exception while trying to handle coroutine exception', thrownException);
      {
      }
      {
        {
        }
      }
      tmp$ret$0 = tmp0_apply_0;
      break $l$block;
    }
    return tmp$ret$0;
  }
  function CoroutineScope() {
  }
  CoroutineScope.$metadata$ = {
    simpleName: 'CoroutineScope',
    kind: 'interface',
    interfaces: []
  };
  function GlobalScope() {
    GlobalScope_instance = this;
  }
  GlobalScope.prototype._get_coroutineContext__2519429620_td3xn0_k$ = function () {
    return EmptyCoroutineContext_getInstance();
  };
  GlobalScope.$metadata$ = {
    simpleName: 'GlobalScope',
    kind: 'object',
    interfaces: [CoroutineScope]
  };
  var GlobalScope_instance;
  function GlobalScope_getInstance() {
    if (GlobalScope_instance == null)
      new GlobalScope();
    return GlobalScope_instance;
  }
  var CoroutineStart_DEFAULT_instance;
  var CoroutineStart_LAZY_instance;
  var CoroutineStart_ATOMIC_instance;
  var CoroutineStart_UNDISPATCHED_instance;
  var CoroutineStart_entriesInitialized;
  function CoroutineStart_initEntries() {
    if (CoroutineStart_entriesInitialized)
      return Unit_getInstance();
    CoroutineStart_entriesInitialized = true;
    CoroutineStart_DEFAULT_instance = new CoroutineStart('DEFAULT', 0);
    CoroutineStart_LAZY_instance = new CoroutineStart('LAZY', 1);
    CoroutineStart_ATOMIC_instance = new CoroutineStart('ATOMIC', 2);
    CoroutineStart_UNDISPATCHED_instance = new CoroutineStart('UNDISPATCHED', 3);
  }
  function CoroutineStart(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  CoroutineStart.prototype.invoke_wxhu2x_k$ = function (block, receiver, completion) {
    var tmp0_subject = this;
    var tmp0 = tmp0_subject._get_ordinal__3363892928_fec5kw_k$();
    var tmp;
    switch (tmp0) {
      case 0:
        tmp = startCoroutineCancellable$default(block, receiver, completion, null, 4, null);
        break;
      case 2:
        tmp = startCoroutine(block, receiver, completion);
        break;
      case 3:
        tmp = startCoroutineUndispatched(block, receiver, completion);
        break;
      case 1:
        tmp = Unit_getInstance();
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    return tmp;
  };
  CoroutineStart.prototype._get_isLazy__54527757_wgpvx_k$ = function () {
    return this === CoroutineStart_LAZY_getInstance();
  };
  CoroutineStart.$metadata$ = {
    simpleName: 'CoroutineStart',
    kind: 'class',
    interfaces: []
  };
  function CoroutineStart_DEFAULT_getInstance() {
    CoroutineStart_initEntries();
    return CoroutineStart_DEFAULT_instance;
  }
  function CoroutineStart_LAZY_getInstance() {
    CoroutineStart_initEntries();
    return CoroutineStart_LAZY_instance;
  }
  function CopyableThrowable() {
  }
  CopyableThrowable.$metadata$ = {
    simpleName: 'CopyableThrowable',
    kind: 'interface',
    interfaces: []
  };
  function Deferred() {
  }
  Deferred.$metadata$ = {
    simpleName: 'Deferred',
    kind: 'interface',
    interfaces: [Job]
  };
  function Delay() {
  }
  Delay.$metadata$ = {
    simpleName: 'Delay',
    kind: 'interface',
    interfaces: []
  };
  function delta($this, unconfined) {
    return unconfined ? new Long(0, 1) : new Long(1, 0);
  }
  function EventLoop() {
    CoroutineDispatcher.call(this);
    this.useCount_1 = new Long(0, 0);
    this.shared_1 = false;
    this.unconfinedQueue_1 = null;
  }
  EventLoop.prototype.processUnconfinedEvent_mypjl6_k$ = function () {
    var tmp0_elvis_lhs = this.unconfinedQueue_1;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return false;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var queue = tmp;
    var tmp1_elvis_lhs = queue.removeFirstOrNull_eges3a_k$();
    var tmp_0;
    if (tmp1_elvis_lhs == null) {
      return false;
    } else {
      tmp_0 = tmp1_elvis_lhs;
    }
    var task = tmp_0;
    task.run_mw4iiu_k$();
    return true;
  };
  EventLoop.prototype.dispatchUnconfined_do6j6f_k$ = function (task) {
    var tmp0_elvis_lhs = this.unconfinedQueue_1;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      var tmp$ret$0;
      $l$block: {
        var tmp0_also_0 = new ArrayQueue();
        {
        }
        {
          this.unconfinedQueue_1 = tmp0_also_0;
        }
        tmp$ret$0 = tmp0_also_0;
        break $l$block;
      }
      tmp = tmp$ret$0;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var queue = tmp;
    queue.addLast_xhfl3v_k$(task);
  };
  EventLoop.prototype._get_isUnconfinedLoopActive__1254651510_kqzjau_k$ = function () {
    return this.useCount_1.compareTo_n4fqi2_k$(delta(this, true)) >= 0;
  };
  EventLoop.prototype._get_isUnconfinedQueueEmpty__1719770308_sfwn9g_k$ = function () {
    var tmp0_safe_receiver = this.unconfinedQueue_1;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver._get_isEmpty__1500737838_oti0q6_k$();
    return tmp1_elvis_lhs == null ? true : tmp1_elvis_lhs;
  };
  EventLoop.prototype.incrementUseCount_ocukpa_k$ = function (unconfined) {
    var tmp0_this = this;
    tmp0_this.useCount_1 = tmp0_this.useCount_1.plus_u6jwas_k$(delta(this, unconfined));
    if (!unconfined)
      this.shared_1 = true;
  };
  EventLoop.prototype.decrementUseCount_saho26_k$ = function (unconfined) {
    var tmp0_this = this;
    tmp0_this.useCount_1 = tmp0_this.useCount_1.minus_llf5ei_k$(delta(this, unconfined));
    if (this.useCount_1.compareTo_n4fqi2_k$(new Long(0, 0)) > 0)
      return Unit_getInstance();
    {
    }
    if (this.shared_1) {
      this.shutdown_cq5p8b_k$();
    }
  };
  EventLoop.prototype.shutdown_cq5p8b_k$ = function () {
  };
  EventLoop.$metadata$ = {
    simpleName: 'EventLoop',
    kind: 'class',
    interfaces: []
  };
  function ThreadLocalEventLoop() {
    ThreadLocalEventLoop_instance = this;
    this.ref_1 = new CommonThreadLocal();
  }
  ThreadLocalEventLoop.prototype._get_eventLoop__3953864115_5n30wd_k$ = function () {
    var tmp0_elvis_lhs = this.ref_1.get_26vq_k$();
    var tmp;
    if (tmp0_elvis_lhs == null) {
      var tmp$ret$0;
      $l$block: {
        var tmp0_also_0 = createEventLoop();
        {
        }
        {
          ThreadLocalEventLoop_getInstance().ref_1.set_hda1d2_k$(tmp0_also_0);
        }
        tmp$ret$0 = tmp0_also_0;
        break $l$block;
      }
      tmp = tmp$ret$0;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  };
  ThreadLocalEventLoop.$metadata$ = {
    simpleName: 'ThreadLocalEventLoop',
    kind: 'object',
    interfaces: []
  };
  var ThreadLocalEventLoop_instance;
  function ThreadLocalEventLoop_getInstance() {
    if (ThreadLocalEventLoop_instance == null)
      new ThreadLocalEventLoop();
    return ThreadLocalEventLoop_instance;
  }
  function CompletionHandlerException(message, cause) {
    RuntimeException_init_$Init$(message, cause, this);
    captureStack(this, CompletionHandlerException);
  }
  CompletionHandlerException.$metadata$ = {
    simpleName: 'CompletionHandlerException',
    kind: 'class',
    interfaces: []
  };
  function CoroutinesInternalError(message, cause) {
    Error_init_$Init$(message, cause, this);
    captureStack(this, CoroutinesInternalError);
  }
  CoroutinesInternalError.$metadata$ = {
    simpleName: 'CoroutinesInternalError',
    kind: 'class',
    interfaces: []
  };
  function DisposableHandle() {
  }
  DisposableHandle.$metadata$ = {
    simpleName: 'DisposableHandle',
    kind: 'interface',
    interfaces: []
  };
  function Key_2() {
    Key_instance_1 = this;
    initializeDefaultExceptionHandlers();
  }
  Key_2.$metadata$ = {
    simpleName: 'Key',
    kind: 'object',
    interfaces: [Key]
  };
  var Key_instance_1;
  function Key_getInstance_2() {
    if (Key_instance_1 == null)
      new Key_2();
    return Key_instance_1;
  }
  function Job() {
  }
  Job.$metadata$ = {
    simpleName: 'Job',
    kind: 'interface',
    interfaces: [Element]
  };
  function ChildJob() {
  }
  ChildJob.$metadata$ = {
    simpleName: 'ChildJob',
    kind: 'interface',
    interfaces: [Job]
  };
  function ParentJob() {
  }
  ParentJob.$metadata$ = {
    simpleName: 'ParentJob',
    kind: 'interface',
    interfaces: [Job]
  };
  function ChildHandle() {
  }
  ChildHandle.$metadata$ = {
    simpleName: 'ChildHandle',
    kind: 'interface',
    interfaces: [DisposableHandle]
  };
  function NonDisposableHandle() {
    NonDisposableHandle_instance = this;
  }
  NonDisposableHandle.prototype.dispose_3n44we_k$ = function () {
  };
  NonDisposableHandle.prototype.childCancelled_fdoq8t_k$ = function (cause) {
    return false;
  };
  NonDisposableHandle.prototype.toString = function () {
    return 'NonDisposableHandle';
  };
  NonDisposableHandle.$metadata$ = {
    simpleName: 'NonDisposableHandle',
    kind: 'object',
    interfaces: [DisposableHandle, ChildHandle]
  };
  var NonDisposableHandle_instance;
  function NonDisposableHandle_getInstance() {
    if (NonDisposableHandle_instance == null)
      new NonDisposableHandle();
    return NonDisposableHandle_instance;
  }
  function _get_COMPLETING_ALREADY__1904323772() {
    init_properties_JobSupport_kt_3188198472();
    return COMPLETING_ALREADY;
  }
  var COMPLETING_ALREADY;
  function _get_COMPLETING_WAITING_CHILDREN__621847959() {
    init_properties_JobSupport_kt_3188198472();
    return COMPLETING_WAITING_CHILDREN;
  }
  var COMPLETING_WAITING_CHILDREN;
  function _get_COMPLETING_RETRY__2730327532() {
    init_properties_JobSupport_kt_3188198472();
    return COMPLETING_RETRY;
  }
  var COMPLETING_RETRY;
  function _get_TOO_LATE_TO_CANCEL__2262851771() {
    init_properties_JobSupport_kt_3188198472();
    return TOO_LATE_TO_CANCEL;
  }
  var TOO_LATE_TO_CANCEL;
  function _get_SEALED__676505391() {
    init_properties_JobSupport_kt_3188198472();
    return SEALED;
  }
  var SEALED;
  function _get_EMPTY_NEW__2442515619() {
    init_properties_JobSupport_kt_3188198472();
    return EMPTY_NEW;
  }
  var EMPTY_NEW;
  function _get_EMPTY_ACTIVE__934614515() {
    init_properties_JobSupport_kt_3188198472();
    return EMPTY_ACTIVE;
  }
  var EMPTY_ACTIVE;
  function Empty(isActive) {
    this.isActive_1 = isActive;
  }
  Empty.prototype._get_isActive__4035225851_4an5s5_k$ = function () {
    return this.isActive_1;
  };
  Empty.prototype._get_list__802566509_d9tsa5_k$ = function () {
    return null;
  };
  Empty.prototype.toString = function () {
    return 'Empty{' + (this.isActive_1 ? 'Active' : 'New') + '}';
  };
  Empty.$metadata$ = {
    simpleName: 'Empty',
    kind: 'class',
    interfaces: [Incomplete]
  };
  function Incomplete() {
  }
  Incomplete.$metadata$ = {
    simpleName: 'Incomplete',
    kind: 'interface',
    interfaces: []
  };
  function NodeList() {
    LinkedListHead.call(this);
  }
  NodeList.prototype._get_isActive__4035225851_4an5s5_k$ = function () {
    return true;
  };
  NodeList.prototype._get_list__802566509_d9tsa5_k$ = function () {
    return this;
  };
  NodeList.prototype.getString_xqex6i_k$ = function (state) {
    var tmp$ret$1;
    $l$block_0: {
      {
      }
      var tmp$ret$0;
      $l$block: {
        var tmp0_apply_0_1 = StringBuilder_init_$Create$();
        {
        }
        {
          tmp0_apply_0_1.append_ssq29y_k$('List{');
          Unit_getInstance();
          tmp0_apply_0_1.append_ssq29y_k$(state);
          Unit_getInstance();
          tmp0_apply_0_1.append_ssq29y_k$('}[');
          Unit_getInstance();
          var first_3 = true;
          {
            var cur_1_4 = this._get__next__3036752447_kt3wsh_k$();
            while (!equals(cur_1_4, this)) {
              if (cur_1_4 instanceof JobNode) {
                var tmp0__anonymous__2_5_1682275472 = cur_1_4;
                if (first_3)
                  first_3 = false;
                else {
                  tmp0_apply_0_1.append_ssq29y_k$(', ');
                  Unit_getInstance();
                }
                tmp0_apply_0_1.append_t8pm91_k$(tmp0__anonymous__2_5_1682275472);
                Unit_getInstance();
              } else {
              }
              cur_1_4 = cur_1_4._get__next__3036752447_kt3wsh_k$();
            }
          }
          tmp0_apply_0_1.append_ssq29y_k$(']');
          Unit_getInstance();
        }
        tmp$ret$0 = tmp0_apply_0_1;
        break $l$block;
      }
      tmp$ret$1 = tmp$ret$0.toString();
      break $l$block_0;
    }
    return tmp$ret$1;
  };
  NodeList.prototype.toString = function () {
    return _get_DEBUG__2224823294() ? this.getString_xqex6i_k$('Active') : anyToString(this);
  };
  NodeList.$metadata$ = {
    simpleName: 'NodeList',
    kind: 'class',
    interfaces: [Incomplete]
  };
  function JobNode() {
    CompletionHandlerBase.call(this);
  }
  JobNode.prototype._get_job__857118836_e6b14k_k$ = function () {
    var tmp = this.job_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('job');
    }
  };
  JobNode.prototype._get_isActive__4035225851_4an5s5_k$ = function () {
    return true;
  };
  JobNode.prototype._get_list__802566509_d9tsa5_k$ = function () {
    return null;
  };
  JobNode.prototype.dispose_3n44we_k$ = function () {
    return this._get_job__857118836_e6b14k_k$().removeNode_o3o6t1_k$(this);
  };
  JobNode.prototype.toString = function () {
    return _get_classSimpleName__3937513404(this) + '@' + _get_hexAddress__2831015762(this) + '[job@' + _get_hexAddress__2831015762(this._get_job__857118836_e6b14k_k$()) + ']';
  };
  JobNode.$metadata$ = {
    simpleName: 'JobNode',
    kind: 'class',
    interfaces: [DisposableHandle, Incomplete]
  };
  function _set_exceptionsHolder__2496749063($this, value) {
    $this._exceptionsHolder_1._set_value__1325260276_x73o94_k$(value);
  }
  function _get_exceptionsHolder__4255505403($this) {
    return $this._exceptionsHolder_1._get_value__3683422336_a43j40_k$();
  }
  function allocateList($this) {
    return ArrayList_init_$Create$(4);
  }
  function finalizeFinishingState($this, state, proposedUpdate) {
    {
    }
    {
    }
    {
    }
    var tmp0_safe_receiver = proposedUpdate instanceof CompletedExceptionally ? proposedUpdate : null;
    var proposedException = tmp0_safe_receiver == null ? null : tmp0_safe_receiver._get_cause__3139734664_j3sn7c_k$();
    var wasCancelling = false;
    var tmp$ret$1;
    $l$block_0: {
      var tmp$ret$0;
      $l$block: {
        wasCancelling = state._get_isCancelling__1064839761_hlz7m9_k$();
        var exceptions_2 = state.sealLocked_11gdw4_k$(proposedException);
        var finalCause_3 = getFinalRootCause($this, state, exceptions_2);
        if (!(finalCause_3 == null))
          addSuppressedExceptions($this, finalCause_3, exceptions_2);
        tmp$ret$0 = finalCause_3;
        break $l$block;
      }
      tmp$ret$1 = tmp$ret$0;
      break $l$block_0;
    }
    var finalException = tmp$ret$1;
    var tmp;
    if (finalException == null) {
      tmp = proposedUpdate;
    } else if (finalException === proposedException) {
      tmp = proposedUpdate;
    } else {
      tmp = CompletedExceptionally_init_$Create$(finalException, false, 2, null);
    }
    var finalState = tmp;
    if (!(finalException == null)) {
      var handled = cancelParent($this, finalException) ? true : $this.handleJobException_oc4gxk_k$(finalException);
      if (handled) {
        (finalState instanceof CompletedExceptionally ? finalState : THROW_CCE()).makeHandled_ws9oq6_k$();
        Unit_getInstance();
      }
    }
    if (!wasCancelling)
      $this.onCancelling_bxyn9n_k$(finalException);
    $this.onCompletionInternal_39c1g8_k$(finalState);
    var casSuccess = $this._state_1.atomicfu$compareAndSet(state, boxIncomplete(finalState));
    {
    }
    completeStateFinalization($this, state, finalState);
    return finalState;
  }
  function getFinalRootCause($this, state, exceptions) {
    if (exceptions.isEmpty_y1axqb_k$()) {
      if (state._get_isCancelling__1064839761_hlz7m9_k$()) {
        var tmp$ret$0;
        $l$block: {
          var tmp0_elvis_lhs_1 = null;
          tmp$ret$0 = new JobCancellationException(tmp0_elvis_lhs_1 == null ? $this.cancellationExceptionMessage_a64063_k$() : tmp0_elvis_lhs_1, null, $this);
          break $l$block;
        }
        return tmp$ret$0;
      }
      return null;
    }
    var tmp$ret$2;
    $l$block_2: {
      var tmp0_iterator_1 = exceptions.iterator_jk1svi_k$();
      while (tmp0_iterator_1.hasNext_bitz1p_k$()) {
        var element_2 = tmp0_iterator_1.next_20eer_k$();
        var tmp$ret$1;
        $l$block_0: {
          tmp$ret$1 = !(element_2 instanceof CancellationException);
          break $l$block_0;
        }
        if (tmp$ret$1) {
          tmp$ret$2 = element_2;
          break $l$block_2;
        } else {
        }
      }
      tmp$ret$2 = null;
      break $l$block_2;
    }
    var firstNonCancellation = tmp$ret$2;
    if (!(firstNonCancellation == null))
      return firstNonCancellation;
    var first = exceptions.get_fkrdnv_k$(0);
    if (first instanceof TimeoutCancellationException) {
      var tmp$ret$4;
      $l$block_5: {
        var tmp0_iterator_1_0 = exceptions.iterator_jk1svi_k$();
        while (tmp0_iterator_1_0.hasNext_bitz1p_k$()) {
          var element_2_0 = tmp0_iterator_1_0.next_20eer_k$();
          var tmp$ret$3;
          $l$block_3: {
            var tmp;
            if (!(element_2_0 === first)) {
              tmp = element_2_0 instanceof TimeoutCancellationException;
            } else {
              tmp = false;
            }
            tmp$ret$3 = tmp;
            break $l$block_3;
          }
          if (tmp$ret$3) {
            tmp$ret$4 = element_2_0;
            break $l$block_5;
          } else {
          }
        }
        tmp$ret$4 = null;
        break $l$block_5;
      }
      var detailedTimeoutException = tmp$ret$4;
      if (!(detailedTimeoutException == null))
        return detailedTimeoutException;
    } else {
    }
    return first;
  }
  function addSuppressedExceptions($this, rootCause, exceptions) {
    if (exceptions._get_size__809037418_ddoh9m_k$() <= 1)
      return Unit_getInstance();
    var seenExceptions = identitySet(exceptions._get_size__809037418_ddoh9m_k$());
    var unwrappedCause = unwrap(rootCause);
    var tmp0_iterator = exceptions.iterator_jk1svi_k$();
    while (tmp0_iterator.hasNext_bitz1p_k$()) {
      var exception = tmp0_iterator.next_20eer_k$();
      var unwrapped = unwrap(exception);
      var tmp;
      var tmp_0;
      if (!(unwrapped === rootCause) ? !(unwrapped === unwrappedCause) : false) {
        tmp_0 = !(unwrapped instanceof CancellationException);
      } else {
        tmp_0 = false;
      }
      if (tmp_0) {
        tmp = seenExceptions.add_1j60pz_k$(unwrapped);
      } else {
        {
          tmp = false;
        }
      }
      if (tmp) {
        {
        }
      } else {
      }
    }
  }
  function tryFinalizeSimpleState($this, state, update) {
    {
    }
    {
    }
    if (!$this._state_1.atomicfu$compareAndSet(state, boxIncomplete(update)))
      return false;
    $this.onCancelling_bxyn9n_k$(null);
    $this.onCompletionInternal_39c1g8_k$(update);
    completeStateFinalization($this, state, update);
    return true;
  }
  function completeStateFinalization($this, state, update) {
    var tmp0_safe_receiver = $this._get_parentHandle__921052185_f8dcex_k$();
    if (tmp0_safe_receiver == null)
      null;
    else {
      var tmp$ret$0;
      $l$block: {
        {
        }
        tmp0_safe_receiver.dispose_3n44we_k$();
        tmp$ret$0 = $this._set_parentHandle__4275866661_guhd0s_k$(NonDisposableHandle_getInstance());
        break $l$block;
      }
      Unit_getInstance();
    }
    Unit_getInstance();
    var tmp1_safe_receiver = update instanceof CompletedExceptionally ? update : null;
    var cause = tmp1_safe_receiver == null ? null : tmp1_safe_receiver._get_cause__3139734664_j3sn7c_k$();
    if (state instanceof JobNode) {
      try {
        state.invoke(cause);
      } catch ($p) {
        if ($p instanceof Error) {
          $this.handleOnCompletionException_o179kb_k$(new CompletionHandlerException('Exception in completion handler ' + state + ' for ' + $this, $p));
        } else {
          {
            throw $p;
          }
        }
      }
    } else {
      {
        var tmp2_safe_receiver = state._get_list__802566509_d9tsa5_k$();
        if (tmp2_safe_receiver == null)
          null;
        else {
          notifyCompletion(tmp2_safe_receiver, $this, cause);
          Unit_getInstance();
        }
        Unit_getInstance();
      }
    }
  }
  function notifyCancelling($this, list, cause) {
    $this.onCancelling_bxyn9n_k$(cause);
    {
      var exception_1 = null;
      {
        var cur_1 = list._get__next__3036752447_kt3wsh_k$();
        while (!equals(cur_1, list)) {
          if (cur_1 instanceof JobCancellingNode) {
            var tmp0__anonymous__2_2_1682275469 = cur_1;
            try {
              tmp0__anonymous__2_2_1682275469.invoke(cause);
            } catch ($p) {
              if ($p instanceof Error) {
                var tmp0_safe_receiver_5_5 = exception_1;
                var tmp;
                if (tmp0_safe_receiver_5_5 == null) {
                  tmp = null;
                } else {
                  var tmp$ret$0;
                  $l$block: {
                    {
                    }
                    {
                      {
                      }
                    }
                    tmp$ret$0 = tmp0_safe_receiver_5_5;
                    break $l$block;
                  }
                  tmp = tmp$ret$0;
                }
                var tmp1_elvis_lhs_4_4 = tmp;
                if (tmp1_elvis_lhs_4_4 == null) {
                  var tmp$ret$1;
                  $l$block_0: {
                    {
                    }
                    exception_1 = new CompletionHandlerException('Exception in completion handler ' + tmp0__anonymous__2_2_1682275469 + ' for ' + $this, $p);
                    tmp$ret$1 = Unit_getInstance();
                    break $l$block_0;
                  }
                  Unit_getInstance();
                } else
                  tmp1_elvis_lhs_4_4;
                Unit_getInstance();
              } else {
                {
                  throw $p;
                }
              }
            }
          } else {
          }
          cur_1 = cur_1._get__next__3036752447_kt3wsh_k$();
        }
      }
      var tmp0_safe_receiver_8 = exception_1;
      if (tmp0_safe_receiver_8 == null)
        null;
      else {
        var tmp$ret$2;
        $l$block_1: {
          {
          }
          tmp$ret$2 = $this.handleOnCompletionException_o179kb_k$(tmp0_safe_receiver_8);
          break $l$block_1;
        }
        Unit_getInstance();
      }
      Unit_getInstance();
    }
    cancelParent($this, cause);
    Unit_getInstance();
  }
  function cancelParent($this, cause) {
    if ($this._get_isScopedCoroutine__175864179_2wpdo3_k$())
      return true;
    var isCancellation = cause instanceof CancellationException;
    var parent = $this._get_parentHandle__921052185_f8dcex_k$();
    if (parent === null ? true : parent === NonDisposableHandle_getInstance()) {
      return isCancellation;
    }
    return parent.childCancelled_fdoq8t_k$(cause) ? true : isCancellation;
  }
  function notifyCompletion(_this__1828080292, $this, cause) {
    var exception_1 = null;
    {
      var cur_1 = _this__1828080292._get__next__3036752447_kt3wsh_k$();
      while (!equals(cur_1, _this__1828080292)) {
        if (cur_1 instanceof JobNode) {
          var tmp0__anonymous__2_2_1682275469 = cur_1;
          try {
            tmp0__anonymous__2_2_1682275469.invoke(cause);
          } catch ($p) {
            if ($p instanceof Error) {
              var tmp0_safe_receiver_5_5 = exception_1;
              var tmp;
              if (tmp0_safe_receiver_5_5 == null) {
                tmp = null;
              } else {
                var tmp$ret$0;
                $l$block: {
                  {
                  }
                  {
                    {
                    }
                  }
                  tmp$ret$0 = tmp0_safe_receiver_5_5;
                  break $l$block;
                }
                tmp = tmp$ret$0;
              }
              var tmp1_elvis_lhs_4_4 = tmp;
              if (tmp1_elvis_lhs_4_4 == null) {
                var tmp$ret$1;
                $l$block_0: {
                  {
                  }
                  exception_1 = new CompletionHandlerException('Exception in completion handler ' + tmp0__anonymous__2_2_1682275469 + ' for ' + $this, $p);
                  tmp$ret$1 = Unit_getInstance();
                  break $l$block_0;
                }
                Unit_getInstance();
              } else
                tmp1_elvis_lhs_4_4;
              Unit_getInstance();
            } else {
              {
                throw $p;
              }
            }
          }
        } else {
        }
        cur_1 = cur_1._get__next__3036752447_kt3wsh_k$();
      }
    }
    var tmp0_safe_receiver_8 = exception_1;
    if (tmp0_safe_receiver_8 == null)
      null;
    else {
      var tmp$ret$2;
      $l$block_1: {
        {
        }
        tmp$ret$2 = $this.handleOnCompletionException_o179kb_k$(tmp0_safe_receiver_8);
        break $l$block_1;
      }
      Unit_getInstance();
    }
    return Unit_getInstance();
  }
  function startInternal($this, state) {
    var tmp0_subject = state;
    if (tmp0_subject instanceof Empty) {
      if (state.isActive_1)
        return 0;
      if (!$this._state_1.atomicfu$compareAndSet(state, _get_EMPTY_ACTIVE__934614515()))
        return -1;
      $this.onStart_qth026_k$();
      return 1;
    } else {
      if (tmp0_subject instanceof InactiveNodeList) {
        if (!$this._state_1.atomicfu$compareAndSet(state, state.list_1))
          return -1;
        $this.onStart_qth026_k$();
        return 1;
      } else {
        return 0;
      }
    }
  }
  function makeNode($this, handler, onCancelling) {
    var tmp;
    if (onCancelling) {
      var tmp0_elvis_lhs = handler instanceof JobCancellingNode ? handler : null;
      tmp = tmp0_elvis_lhs == null ? new InvokeOnCancelling(handler) : tmp0_elvis_lhs;
    } else {
      var tmp1_safe_receiver = handler instanceof JobNode ? handler : null;
      var tmp_0;
      if (tmp1_safe_receiver == null) {
        tmp_0 = null;
      } else {
        var tmp$ret$0;
        $l$block: {
          {
          }
          {
            {
            }
          }
          tmp$ret$0 = tmp1_safe_receiver;
          break $l$block;
        }
        tmp_0 = tmp$ret$0;
      }
      var tmp2_elvis_lhs = tmp_0;
      tmp = tmp2_elvis_lhs == null ? new InvokeOnCompletion(handler) : tmp2_elvis_lhs;
    }
    var node = tmp;
    node.job_1 = $this;
    return node;
  }
  function addLastAtomic($this, expect, list, node) {
    var tmp$ret$1;
    $l$block_1: {
      var tmp$ret$0;
      $l$block: {
        tmp$ret$0 = $this._get_state__3614753120_b8zcm8_k$() === expect;
        break $l$block;
      }
      if (!tmp$ret$0) {
        tmp$ret$1 = false;
        break $l$block_1;
      } else {
      }
      list.addLast_uyctnf_k$(node);
      tmp$ret$1 = true;
      break $l$block_1;
    }
    return tmp$ret$1;
  }
  function promoteEmptyToNodeList($this, state) {
    var list = new NodeList();
    var update = state.isActive_1 ? list : new InactiveNodeList(list);
    $this._state_1.atomicfu$compareAndSet(state, update);
    Unit_getInstance();
  }
  function promoteSingleToNodeList($this, state) {
    state.addOneIfEmpty_cbgboi_k$(new NodeList());
    Unit_getInstance();
    var tmp$ret$0;
    $l$block: {
      tmp$ret$0 = state._get__next__3036752447_kt3wsh_k$();
      break $l$block;
    }
    var list = tmp$ret$0;
    $this._state_1.atomicfu$compareAndSet(state, list);
    Unit_getInstance();
  }
  function cancelMakeCompleting($this, cause) {
    {
      while (true) {
        {
          var tmp0__anonymous__1_2495602521 = $this._get_state__3614753120_b8zcm8_k$();
          var tmp;
          if (!(!(tmp0__anonymous__1_2495602521 == null) ? isInterface(tmp0__anonymous__1_2495602521, Incomplete) : false)) {
            tmp = true;
          } else {
            {
              var tmp_0;
              if (tmp0__anonymous__1_2495602521 instanceof Finishing) {
                tmp_0 = tmp0__anonymous__1_2495602521._get_isCompleting__3027345611_kypj5h_k$();
              } else {
                {
                  tmp_0 = false;
                }
              }
              tmp = tmp_0;
            }
          }
          if (tmp) {
            return _get_COMPLETING_ALREADY__1904323772();
          } else {
          }
          var tmp_1 = createCauseException($this, cause);
          var proposedUpdate_2 = CompletedExceptionally_init_$Create$(tmp_1, false, 2, null);
          var finalState_3 = tryMakeCompleting($this, tmp0__anonymous__1_2495602521, proposedUpdate_2);
          if (!(finalState_3 === _get_COMPLETING_RETRY__2730327532()))
            return finalState_3;
        }
      }
      Unit_getInstance();
    }
  }
  function createCauseException($this, cause) {
    var tmp0_subject = cause;
    var tmp;
    if (tmp0_subject == null ? true : tmp0_subject instanceof Error) {
      var tmp1_elvis_lhs = cause;
      var tmp_0;
      if (tmp1_elvis_lhs == null) {
        var tmp$ret$0;
        $l$block: {
          var tmp0_elvis_lhs_1 = null;
          tmp$ret$0 = new JobCancellationException(tmp0_elvis_lhs_1 == null ? $this.cancellationExceptionMessage_a64063_k$() : tmp0_elvis_lhs_1, null, $this);
          break $l$block;
        }
        tmp_0 = tmp$ret$0;
      } else {
        tmp_0 = tmp1_elvis_lhs;
      }
      tmp = tmp_0;
    } else {
      {
        tmp = ((!(cause == null) ? isInterface(cause, ParentJob) : false) ? cause : THROW_CCE()).getChildJobCancellationCause_wx9uoh_k$();
      }
    }
    return tmp;
  }
  function makeCancelling($this, cause) {
    var causeExceptionCache = null;
    {
      while (true) {
        var tmp$ret$7;
        $l$block_6: {
          var tmp0__anonymous__1_2495602521 = $this._get_state__3614753120_b8zcm8_k$();
          var tmp0_subject_2 = tmp0__anonymous__1_2495602521;
          if (tmp0_subject_2 instanceof Finishing) {
            var tmp$ret$4;
            $l$block_3: {
              var tmp$ret$3;
              $l$block_2: {
                if (tmp0__anonymous__1_2495602521._get_isSealed__2870207333_nk9jtn_k$())
                  return _get_TOO_LATE_TO_CANCEL__2262851771();
                var wasCancelling_2_4 = tmp0__anonymous__1_2495602521._get_isCancelling__1064839761_hlz7m9_k$();
                if (!(cause == null) ? true : !wasCancelling_2_4) {
                  var tmp0_elvis_lhs_4_6 = causeExceptionCache;
                  var tmp;
                  if (tmp0_elvis_lhs_4_6 == null) {
                    var tmp$ret$0;
                    $l$block: {
                      var tmp0_also_0_5_7 = createCauseException($this, cause);
                      {
                      }
                      {
                        causeExceptionCache = tmp0_also_0_5_7;
                      }
                      tmp$ret$0 = tmp0_also_0_5_7;
                      break $l$block;
                    }
                    tmp = tmp$ret$0;
                  } else {
                    tmp = tmp0_elvis_lhs_4_6;
                  }
                  var causeException_3_5 = tmp;
                  tmp0__anonymous__1_2495602521.addExceptionLocked_jeuhbd_k$(causeException_3_5);
                }
                var tmp$ret$2;
                $l$block_1: {
                  var tmp1_takeIf_0_6_8 = tmp0__anonymous__1_2495602521._get_rootCause__1061504650_hjzq8a_k$();
                  {
                  }
                  var tmp_0;
                  var tmp$ret$1;
                  $l$block_0: {
                    tmp$ret$1 = !wasCancelling_2_4;
                    break $l$block_0;
                  }
                  if (tmp$ret$1) {
                    tmp_0 = tmp1_takeIf_0_6_8;
                  } else {
                    {
                      tmp_0 = null;
                    }
                  }
                  tmp$ret$2 = tmp_0;
                  break $l$block_1;
                }
                tmp$ret$3 = tmp$ret$2;
                break $l$block_2;
              }
              tmp$ret$4 = tmp$ret$3;
              break $l$block_3;
            }
            var notifyRootCause_3 = tmp$ret$4;
            var tmp1_safe_receiver_9 = notifyRootCause_3;
            if (tmp1_safe_receiver_9 == null)
              null;
            else {
              var tmp$ret$5;
              $l$block_4: {
                {
                }
                tmp$ret$5 = notifyCancelling($this, tmp0__anonymous__1_2495602521.list_1, tmp1_safe_receiver_9);
                break $l$block_4;
              }
              Unit_getInstance();
            }
            Unit_getInstance();
            return _get_COMPLETING_ALREADY__1904323772();
          } else {
            if (!(tmp0_subject_2 == null) ? isInterface(tmp0_subject_2, Incomplete) : false) {
              var tmp2_elvis_lhs_11 = causeExceptionCache;
              var tmp_1;
              if (tmp2_elvis_lhs_11 == null) {
                var tmp$ret$6;
                $l$block_5: {
                  var tmp0_also_0_12 = createCauseException($this, cause);
                  {
                  }
                  {
                    causeExceptionCache = tmp0_also_0_12;
                  }
                  tmp$ret$6 = tmp0_also_0_12;
                  break $l$block_5;
                }
                tmp_1 = tmp$ret$6;
              } else {
                tmp_1 = tmp2_elvis_lhs_11;
              }
              var causeException_10 = tmp_1;
              if (tmp0__anonymous__1_2495602521._get_isActive__4035225851_4an5s5_k$()) {
                if (tryMakeCancelling($this, tmp0__anonymous__1_2495602521, causeException_10))
                  return _get_COMPLETING_ALREADY__1904323772();
              } else {
                var finalState_13 = tryMakeCompleting($this, tmp0__anonymous__1_2495602521, CompletedExceptionally_init_$Create$(causeException_10, false, 2, null));
                if (finalState_13 === _get_COMPLETING_ALREADY__1904323772()) {
                  var tmp1_error_0_14 = 'Cannot happen in ' + toString(tmp0__anonymous__1_2495602521);
                  throw IllegalStateException_init_$Create$(toString_0(tmp1_error_0_14));
                } else if (finalState_13 === _get_COMPLETING_RETRY__2730327532()) {
                  tmp$ret$7 = Unit_getInstance();
                  break $l$block_6;
                } else
                  return finalState_13;
              }
            } else {
              return _get_TOO_LATE_TO_CANCEL__2262851771();
            }
          }
        }
      }
      Unit_getInstance();
    }
  }
  function getOrPromoteCancellingList($this, state) {
    var tmp1_elvis_lhs = state._get_list__802566509_d9tsa5_k$();
    var tmp;
    if (tmp1_elvis_lhs == null) {
      var tmp0_subject = state;
      var tmp_0;
      if (tmp0_subject instanceof Empty) {
        tmp_0 = new NodeList();
      } else {
        if (tmp0_subject instanceof JobNode) {
          promoteSingleToNodeList($this, state);
          tmp_0 = null;
        } else {
          {
            var tmp0_error_0 = 'State should have list: ' + state;
            throw IllegalStateException_init_$Create$(toString_0(tmp0_error_0));
          }
        }
      }
      tmp = tmp_0;
    } else {
      tmp = tmp1_elvis_lhs;
    }
    return tmp;
  }
  function tryMakeCancelling($this, state, rootCause) {
    {
    }
    {
    }
    var tmp0_elvis_lhs = getOrPromoteCancellingList($this, state);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return false;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var list = tmp;
    var cancelling = new Finishing(list, false, rootCause);
    if (!$this._state_1.atomicfu$compareAndSet(state, cancelling))
      return false;
    notifyCancelling($this, list, rootCause);
    return true;
  }
  function tryMakeCompleting($this, state, proposedUpdate) {
    if (!(!(state == null) ? isInterface(state, Incomplete) : false))
      return _get_COMPLETING_ALREADY__1904323772();
    else {
    }
    var tmp;
    var tmp_0;
    var tmp_1;
    if (state instanceof Empty) {
      tmp_1 = true;
    } else {
      {
        tmp_1 = state instanceof JobNode;
      }
    }
    if (tmp_1) {
      tmp_0 = !(state instanceof ChildHandleNode);
    } else {
      {
        tmp_0 = false;
      }
    }
    if (tmp_0) {
      tmp = !(proposedUpdate instanceof CompletedExceptionally);
    } else {
      {
        tmp = false;
      }
    }
    if (tmp) {
      if (tryFinalizeSimpleState($this, state, proposedUpdate)) {
        return proposedUpdate;
      }
      return _get_COMPLETING_RETRY__2730327532();
    } else {
    }
    return tryMakeCompletingSlowPath($this, state, proposedUpdate);
  }
  function tryMakeCompletingSlowPath($this, state, proposedUpdate) {
    var tmp0_elvis_lhs = getOrPromoteCancellingList($this, state);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return _get_COMPLETING_RETRY__2730327532();
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var list = tmp;
    var tmp1_elvis_lhs = state instanceof Finishing ? state : null;
    var finishing = tmp1_elvis_lhs == null ? new Finishing(list, false, null) : tmp1_elvis_lhs;
    var notifyRootCause = null;
    var tmp$ret$3;
    $l$block_2: {
      if (finishing._get_isCompleting__3027345611_kypj5h_k$())
        return _get_COMPLETING_ALREADY__1904323772();
      finishing._set_isCompleting__2087192791_wiracy_k$(true);
      if (!(finishing === state)) {
        if (!$this._state_1.atomicfu$compareAndSet(state, finishing))
          return _get_COMPLETING_RETRY__2730327532();
      }
      {
      }
      var wasCancelling_2 = finishing._get_isCancelling__1064839761_hlz7m9_k$();
      var tmp0_safe_receiver_3 = proposedUpdate instanceof CompletedExceptionally ? proposedUpdate : null;
      if (tmp0_safe_receiver_3 == null)
        null;
      else {
        var tmp$ret$0;
        $l$block: {
          {
          }
          tmp$ret$0 = finishing.addExceptionLocked_jeuhbd_k$(tmp0_safe_receiver_3._get_cause__3139734664_j3sn7c_k$());
          break $l$block;
        }
        Unit_getInstance();
      }
      Unit_getInstance();
      var tmp$ret$2;
      $l$block_1: {
        var tmp0_takeIf_0_4 = finishing._get_rootCause__1061504650_hjzq8a_k$();
        {
        }
        var tmp_0;
        var tmp$ret$1;
        $l$block_0: {
          tmp$ret$1 = !wasCancelling_2;
          break $l$block_0;
        }
        if (tmp$ret$1) {
          tmp_0 = tmp0_takeIf_0_4;
        } else {
          {
            tmp_0 = null;
          }
        }
        tmp$ret$2 = tmp_0;
        break $l$block_1;
      }
      notifyRootCause = tmp$ret$2;
      tmp$ret$3 = Unit_getInstance();
      break $l$block_2;
    }
    var tmp2_safe_receiver = notifyRootCause;
    if (tmp2_safe_receiver == null)
      null;
    else {
      var tmp$ret$4;
      $l$block_3: {
        {
        }
        tmp$ret$4 = notifyCancelling($this, list, tmp2_safe_receiver);
        break $l$block_3;
      }
      Unit_getInstance();
    }
    Unit_getInstance();
    var child = firstChild($this, state);
    if (!(child == null) ? tryWaitForChild($this, finishing, child, proposedUpdate) : false)
      return _get_COMPLETING_WAITING_CHILDREN__621847959();
    return finalizeFinishingState($this, finishing, proposedUpdate);
  }
  function _get_exceptionOrNull__671063032(_this__1828080292, $this) {
    var tmp0_safe_receiver = _this__1828080292 instanceof CompletedExceptionally ? _this__1828080292 : null;
    return tmp0_safe_receiver == null ? null : tmp0_safe_receiver._get_cause__3139734664_j3sn7c_k$();
  }
  function firstChild($this, state) {
    var tmp1_elvis_lhs = state instanceof ChildHandleNode ? state : null;
    var tmp;
    if (tmp1_elvis_lhs == null) {
      var tmp0_safe_receiver = state._get_list__802566509_d9tsa5_k$();
      tmp = tmp0_safe_receiver == null ? null : nextChild(tmp0_safe_receiver, $this);
    } else {
      tmp = tmp1_elvis_lhs;
    }
    return tmp;
  }
  function tryWaitForChild($this, state, child, proposedUpdate) {
    var $this_0 = $this;
    var state_0 = state;
    var child_0 = child;
    var proposedUpdate_0 = proposedUpdate;
    while (true) {
      var $this_1 = $this_0;
      var state_1 = state_0;
      var child_1 = child_0;
      var proposedUpdate_1 = proposedUpdate_0;
      var tmp$ret$1;
      $l$block_0: {
        var tmp0__get_asHandler__0_1201048388 = new ChildCompletion($this_1, state_1, child_1, proposedUpdate_1);
        var tmp$ret$0;
        $l$block: {
          tmp$ret$0 = tmp0__get_asHandler__0_1201048388;
          break $l$block;
        }
        tmp$ret$1 = tmp$ret$0;
        break $l$block_0;
      }
      var handle = child_1.childJob_1.invokeOnCompletion$default_7q548c_k$(false, false, tmp$ret$1, 1, null);
      if (!(handle === NonDisposableHandle_getInstance()))
        return true;
      var tmp0_elvis_lhs = nextChild(child_1, $this_1);
      var tmp;
      if (tmp0_elvis_lhs == null) {
        return false;
      } else {
        tmp = tmp0_elvis_lhs;
      }
      var nextChild_0 = tmp;
      var tmp0 = $this_1;
      var tmp1 = state_1;
      var tmp2 = nextChild_0;
      var tmp3 = proposedUpdate_1;
      $this_0 = tmp0;
      state_0 = tmp1;
      child_0 = tmp2;
      proposedUpdate_0 = tmp3;
      continue;
    }
  }
  function continueCompleting($this, state, lastChild, proposedUpdate) {
    {
    }
    var waitChild = nextChild(lastChild, $this);
    if (!(waitChild == null) ? tryWaitForChild($this, state, waitChild, proposedUpdate) : false)
      return Unit_getInstance();
    var finalState = finalizeFinishingState($this, state, proposedUpdate);
    $this.afterCompletion_2ogq6g_k$(finalState);
  }
  function nextChild(_this__1828080292, $this) {
    var cur = _this__1828080292;
    $l$loop: while (true) {
      var tmp$ret$0;
      $l$block: {
        var tmp0__get_isRemoved__0_1344361830 = cur;
        tmp$ret$0 = tmp0__get_isRemoved__0_1344361830._get__removed__1059529930_hiteiy_k$();
        break $l$block;
      }
      if (!tmp$ret$0) {
        break $l$loop;
      }
      var tmp$ret$1;
      $l$block_0: {
        var tmp1__get_prevNode__0_2635487596 = cur;
        tmp$ret$1 = tmp1__get_prevNode__0_2635487596._get__prev__3038968575_krsetd_k$();
        break $l$block_0;
      }
      cur = tmp$ret$1;
    }
    $l$loop_0: while (true) {
      var tmp$ret$2;
      $l$block_1: {
        var tmp2__get_nextNode__0_24509131 = cur;
        tmp$ret$2 = tmp2__get_nextNode__0_24509131._get__next__3036752447_kt3wsh_k$();
        break $l$block_1;
      }
      cur = tmp$ret$2;
      var tmp$ret$3;
      $l$block_2: {
        var tmp3__get_isRemoved__0_3105913513 = cur;
        tmp$ret$3 = tmp3__get_isRemoved__0_3105913513._get__removed__1059529930_hiteiy_k$();
        break $l$block_2;
      }
      if (tmp$ret$3)
        continue $l$loop_0;
      else {
      }
      if (cur instanceof ChildHandleNode)
        return cur;
      else {
      }
      if (cur instanceof NodeList)
        return null;
      else {
      }
    }
  }
  function stateString($this, state) {
    var tmp0_subject = state;
    var tmp;
    if (tmp0_subject instanceof Finishing) {
      tmp = state._get_isCancelling__1064839761_hlz7m9_k$() ? 'Cancelling' : state._get_isCompleting__3027345611_kypj5h_k$() ? 'Completing' : 'Active';
    } else {
      if (!(tmp0_subject == null) ? isInterface(tmp0_subject, Incomplete) : false) {
        tmp = state._get_isActive__4035225851_4an5s5_k$() ? 'Active' : 'New';
      } else {
        if (tmp0_subject instanceof CompletedExceptionally) {
          tmp = 'Cancelled';
        } else {
          {
            tmp = 'Completed';
          }
        }
      }
    }
    return tmp;
  }
  function Finishing(list, isCompleting, rootCause) {
    this.list_1 = list;
    this._isCompleting_1 = atomic$boolean$1(isCompleting);
    this._rootCause_1 = atomic$ref$1(rootCause);
    this._exceptionsHolder_1 = atomic$ref$1(null);
  }
  Finishing.prototype._get_list__802566509_d9tsa5_k$ = function () {
    return this.list_1;
  };
  Finishing.prototype._set_isCompleting__2087192791_wiracy_k$ = function (value) {
    this._isCompleting_1._set_value__1325260276_9lpcvp_k$(value);
  };
  Finishing.prototype._get_isCompleting__3027345611_kypj5h_k$ = function () {
    return this._isCompleting_1._get_value__3683422336_a43j40_k$();
  };
  Finishing.prototype._set_rootCause__3584735742_ay25nq_k$ = function (value) {
    this._rootCause_1._set_value__1325260276_x73o94_k$(value);
  };
  Finishing.prototype._get_rootCause__1061504650_hjzq8a_k$ = function () {
    return this._rootCause_1._get_value__3683422336_a43j40_k$();
  };
  Finishing.prototype._get_isSealed__2870207333_nk9jtn_k$ = function () {
    return _get_exceptionsHolder__4255505403(this) === _get_SEALED__676505391();
  };
  Finishing.prototype._get_isCancelling__1064839761_hlz7m9_k$ = function () {
    return !(this._get_rootCause__1061504650_hjzq8a_k$() == null);
  };
  Finishing.prototype._get_isActive__4035225851_4an5s5_k$ = function () {
    return this._get_rootCause__1061504650_hjzq8a_k$() == null;
  };
  Finishing.prototype.sealLocked_11gdw4_k$ = function (proposedException) {
    var eh = _get_exceptionsHolder__4255505403(this);
    var tmp;
    if (eh == null) {
      tmp = allocateList(this);
    } else {
      if (eh instanceof Error) {
        var tmp$ret$0;
        $l$block: {
          var tmp0_also_0 = allocateList(this);
          {
          }
          {
            tmp0_also_0.add_1j60pz_k$(eh);
            Unit_getInstance();
          }
          tmp$ret$0 = tmp0_also_0;
          break $l$block;
        }
        tmp = tmp$ret$0;
      } else {
        if (eh instanceof ArrayList) {
          tmp = eh instanceof ArrayList ? eh : THROW_CCE();
        } else {
          {
            var tmp1_error_0 = 'State is ' + toString(eh);
            throw IllegalStateException_init_$Create$(toString_0(tmp1_error_0));
          }
        }
      }
    }
    var list = tmp;
    var rootCause = this._get_rootCause__1061504650_hjzq8a_k$();
    var tmp0_safe_receiver = rootCause;
    if (tmp0_safe_receiver == null)
      null;
    else {
      var tmp$ret$1;
      $l$block_0: {
        {
        }
        tmp$ret$1 = list.add_ydlf05_k$(0, tmp0_safe_receiver);
        break $l$block_0;
      }
      Unit_getInstance();
    }
    Unit_getInstance();
    if (!(proposedException == null) ? !equals(proposedException, rootCause) : false) {
      list.add_1j60pz_k$(proposedException);
      Unit_getInstance();
    }
    _set_exceptionsHolder__2496749063(this, _get_SEALED__676505391());
    return list;
  };
  Finishing.prototype.addExceptionLocked_jeuhbd_k$ = function (exception) {
    var rootCause = this._get_rootCause__1061504650_hjzq8a_k$();
    if (rootCause == null) {
      this._set_rootCause__3584735742_ay25nq_k$(exception);
      return Unit_getInstance();
    }
    if (exception === rootCause)
      return Unit_getInstance();
    var eh = _get_exceptionsHolder__4255505403(this);
    if (eh == null)
      _set_exceptionsHolder__2496749063(this, exception);
    else {
      if (eh instanceof Error) {
        if (exception === eh)
          return Unit_getInstance();
        var tmp$ret$0;
        $l$block: {
          var tmp0_apply_0 = allocateList(this);
          {
          }
          {
            tmp0_apply_0.add_1j60pz_k$(eh);
            Unit_getInstance();
            tmp0_apply_0.add_1j60pz_k$(exception);
            Unit_getInstance();
          }
          tmp$ret$0 = tmp0_apply_0;
          break $l$block;
        }
        _set_exceptionsHolder__2496749063(this, tmp$ret$0);
      } else {
        if (eh instanceof ArrayList) {
          (eh instanceof ArrayList ? eh : THROW_CCE()).add_1j60pz_k$(exception);
          Unit_getInstance();
        } else {
          {
            var tmp1_error_0 = 'State is ' + toString(eh);
            throw IllegalStateException_init_$Create$(toString_0(tmp1_error_0));
          }
        }
      }
    }
  };
  Finishing.prototype.toString = function () {
    return 'Finishing[cancelling=' + this._get_isCancelling__1064839761_hlz7m9_k$() + ', completing=' + this._get_isCompleting__3027345611_kypj5h_k$() + ', rootCause=' + this._get_rootCause__1061504650_hjzq8a_k$() + ', exceptions=' + toString(_get_exceptionsHolder__4255505403(this)) + ', list=' + this.list_1 + ']';
  };
  Finishing.$metadata$ = {
    simpleName: 'Finishing',
    kind: 'class',
    interfaces: [Incomplete]
  };
  function ChildCompletion(parent, state, child, proposedUpdate) {
    JobNode.call(this);
    this.parent_1 = parent;
    this.state_1 = state;
    this.child_1 = child;
    this.proposedUpdate_1 = proposedUpdate;
  }
  ChildCompletion.prototype.invoke_7fb7sc_k$ = function (cause) {
    continueCompleting(this.parent_1, this.state_1, this.child_1, this.proposedUpdate_1);
  };
  ChildCompletion.prototype.invoke = function (cause) {
    return this.invoke_7fb7sc_k$(cause);
  };
  ChildCompletion.$metadata$ = {
    simpleName: 'ChildCompletion',
    kind: 'class',
    interfaces: []
  };
  function JobSupport(active) {
    this._state_1 = atomic$ref$1(active ? _get_EMPTY_ACTIVE__934614515() : _get_EMPTY_NEW__2442515619());
    this._parentHandle_1 = atomic$ref$1(null);
  }
  JobSupport.prototype._get_key__857139730_e6bh8y_k$ = function () {
    return Key_getInstance_2();
  };
  JobSupport.prototype._set_parentHandle__4275866661_guhd0s_k$ = function (value) {
    this._parentHandle_1._set_value__1325260276_x73o94_k$(value);
  };
  JobSupport.prototype._get_parentHandle__921052185_f8dcex_k$ = function () {
    return this._parentHandle_1._get_value__3683422336_a43j40_k$();
  };
  JobSupport.prototype.initParentJob_4c2lht_k$ = function (parent) {
    {
    }
    if (parent == null) {
      this._set_parentHandle__4275866661_guhd0s_k$(NonDisposableHandle_getInstance());
      return Unit_getInstance();
    }
    parent.start_1tchgi_k$();
    Unit_getInstance();
    var handle = parent.attachChild_ik9c8b_k$(this);
    this._set_parentHandle__4275866661_guhd0s_k$(handle);
    if (this._get_isCompleted__3284240752_gprdlc_k$()) {
      handle.dispose_3n44we_k$();
      this._set_parentHandle__4275866661_guhd0s_k$(NonDisposableHandle_getInstance());
    }
  };
  JobSupport.prototype._get_state__3614753120_b8zcm8_k$ = function () {
    {
      var tmp0_loop_0 = this._state_1;
      while (true) {
        {
          var tmp1__anonymous__1_4003154330 = tmp0_loop_0._get_value__3683422336_a43j40_k$();
          if (!(tmp1__anonymous__1_4003154330 instanceof OpDescriptor))
            return tmp1__anonymous__1_4003154330;
          else {
          }
          tmp1__anonymous__1_4003154330.perform_8emi3i_k$(this);
          Unit_getInstance();
        }
      }
      Unit_getInstance();
    }
  };
  JobSupport.prototype._get_isActive__4035225851_4an5s5_k$ = function () {
    var state = this._get_state__3614753120_b8zcm8_k$();
    var tmp;
    if (!(state == null) ? isInterface(state, Incomplete) : false) {
      tmp = state._get_isActive__4035225851_4an5s5_k$();
    } else {
      {
        tmp = false;
      }
    }
    return tmp;
  };
  JobSupport.prototype._get_isCompleted__3284240752_gprdlc_k$ = function () {
    var tmp = this._get_state__3614753120_b8zcm8_k$();
    return !(!(tmp == null) ? isInterface(tmp, Incomplete) : false);
  };
  JobSupport.prototype.start_1tchgi_k$ = function () {
    {
      while (true) {
        {
          var tmp0__anonymous__1_2495602521 = this._get_state__3614753120_b8zcm8_k$();
          var tmp0_subject_2 = startInternal(this, tmp0__anonymous__1_2495602521);
          if (tmp0_subject_2 === 0)
            return false;
          else if (tmp0_subject_2 === 1)
            return true;
        }
      }
      Unit_getInstance();
    }
  };
  JobSupport.prototype.onStart_qth026_k$ = function () {
  };
  JobSupport.prototype.getCancellationException_8i1q6u_k$ = function () {
    var state = this._get_state__3614753120_b8zcm8_k$();
    var tmp;
    if (state instanceof Finishing) {
      var tmp0_safe_receiver = state._get_rootCause__1061504650_hjzq8a_k$();
      var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : this.toCancellationException_8ve25p_k$(tmp0_safe_receiver, _get_classSimpleName__3937513404(this) + ' is cancelling');
      var tmp_0;
      if (tmp1_elvis_lhs == null) {
        var tmp0_error_0 = 'Job is still new or active: ' + this;
        throw IllegalStateException_init_$Create$(toString_0(tmp0_error_0));
      } else {
        tmp_0 = tmp1_elvis_lhs;
      }
      tmp = tmp_0;
    } else {
      if (!(state == null) ? isInterface(state, Incomplete) : false) {
        var tmp1_error_0 = 'Job is still new or active: ' + this;
        throw IllegalStateException_init_$Create$(toString_0(tmp1_error_0));
      } else {
        if (state instanceof CompletedExceptionally) {
          var tmp_1 = state._get_cause__3139734664_j3sn7c_k$();
          tmp = this.toCancellationException$default_c99ojs_k$(tmp_1, null, 1, null);
        } else {
          {
            tmp = new JobCancellationException(_get_classSimpleName__3937513404(this) + ' has completed normally', null, this);
          }
        }
      }
    }
    return tmp;
  };
  JobSupport.prototype.toCancellationException_8ve25p_k$ = function (_this__1828080292, message) {
    var tmp0_elvis_lhs = _this__1828080292 instanceof CancellationException ? _this__1828080292 : null;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      var tmp$ret$0;
      $l$block: {
        var tmp0_elvis_lhs_1 = message;
        tmp$ret$0 = new JobCancellationException(tmp0_elvis_lhs_1 == null ? this.cancellationExceptionMessage_a64063_k$() : tmp0_elvis_lhs_1, _this__1828080292, this);
        break $l$block;
      }
      tmp = tmp$ret$0;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  };
  JobSupport.prototype.toCancellationException$default_c99ojs_k$ = function (_this__1828080292, message, $mask0, $handler) {
    if (!(($mask0 & 1) === 0))
      message = null;
    return this.toCancellationException_8ve25p_k$(_this__1828080292, message);
  };
  JobSupport.prototype.invokeOnCompletion_t2apld_k$ = function (handler) {
    return this.invokeOnCompletion_npwpyn_k$(false, true, handler);
  };
  JobSupport.prototype.invokeOnCompletion_npwpyn_k$ = function (onCancelling, invokeImmediately, handler) {
    var node = makeNode(this, handler, onCancelling);
    {
      while (true) {
        var tmp$ret$1;
        $l$block_0: {
          var tmp0__anonymous__1_2495602521 = this._get_state__3614753120_b8zcm8_k$();
          var tmp0_subject_2 = tmp0__anonymous__1_2495602521;
          if (tmp0_subject_2 instanceof Empty) {
            if (tmp0__anonymous__1_2495602521.isActive_1) {
              if (this._state_1.atomicfu$compareAndSet(tmp0__anonymous__1_2495602521, node))
                return node;
            } else
              promoteEmptyToNodeList(this, tmp0__anonymous__1_2495602521);
          } else {
            if (!(tmp0_subject_2 == null) ? isInterface(tmp0_subject_2, Incomplete) : false) {
              var list_3 = tmp0__anonymous__1_2495602521._get_list__802566509_d9tsa5_k$();
              if (list_3 == null) {
                promoteSingleToNodeList(this, tmp0__anonymous__1_2495602521 instanceof JobNode ? tmp0__anonymous__1_2495602521 : THROW_CCE());
              } else {
                var rootCause_4 = null;
                var handle_5 = NonDisposableHandle_getInstance();
                var tmp;
                if (onCancelling) {
                  tmp = tmp0__anonymous__1_2495602521 instanceof Finishing;
                } else {
                  tmp = false;
                }
                if (tmp) {
                  var tmp$ret$2;
                  $l$block_1: {
                    rootCause_4 = tmp0__anonymous__1_2495602521._get_rootCause__1061504650_hjzq8a_k$();
                    var tmp_0;
                    var tmp_1;
                    if (rootCause_4 == null) {
                      tmp_1 = true;
                    } else {
                      var tmp_2;
                      var tmp$ret$0;
                      $l$block: {
                        tmp$ret$0 = handler instanceof ChildHandleNode;
                        break $l$block;
                      }
                      if (tmp$ret$0) {
                        tmp_2 = !tmp0__anonymous__1_2495602521._get_isCompleting__3027345611_kypj5h_k$();
                      } else {
                        {
                          tmp_2 = false;
                        }
                      }
                      tmp_1 = tmp_2;
                    }
                    if (tmp_1) {
                      if (!addLastAtomic(this, tmp0__anonymous__1_2495602521, list_3, node)) {
                        tmp$ret$1 = Unit_getInstance();
                        break $l$block_0;
                      }
                      if (rootCause_4 == null)
                        return node;
                      handle_5 = node;
                      tmp_0 = Unit_getInstance();
                    } else {
                    }
                    tmp$ret$2 = tmp_0;
                    break $l$block_1;
                  }
                } else {
                }
                if (!(rootCause_4 == null)) {
                  if (invokeImmediately)
                    invokeIt(handler, rootCause_4);
                  return handle_5;
                } else {
                  if (addLastAtomic(this, tmp0__anonymous__1_2495602521, list_3, node))
                    return node;
                }
              }
            } else {
              {
                if (invokeImmediately) {
                  var tmp1_safe_receiver_6 = tmp0__anonymous__1_2495602521 instanceof CompletedExceptionally ? tmp0__anonymous__1_2495602521 : null;
                  invokeIt(handler, tmp1_safe_receiver_6 == null ? null : tmp1_safe_receiver_6._get_cause__3139734664_j3sn7c_k$());
                }
                return NonDisposableHandle_getInstance();
              }
            }
          }
        }
      }
      Unit_getInstance();
    }
  };
  JobSupport.prototype.removeNode_o3o6t1_k$ = function (node) {
    {
      while (true) {
        {
          var tmp0__anonymous__1_2495602521 = this._get_state__3614753120_b8zcm8_k$();
          var tmp0_subject_2 = tmp0__anonymous__1_2495602521;
          if (tmp0_subject_2 instanceof JobNode) {
            if (!(tmp0__anonymous__1_2495602521 === node))
              return Unit_getInstance();
            if (this._state_1.atomicfu$compareAndSet(tmp0__anonymous__1_2495602521, _get_EMPTY_ACTIVE__934614515()))
              return Unit_getInstance();
          } else {
            if (!(tmp0_subject_2 == null) ? isInterface(tmp0_subject_2, Incomplete) : false) {
              if (!(tmp0__anonymous__1_2495602521._get_list__802566509_d9tsa5_k$() == null)) {
                node.remove_fgfybg_k$();
                Unit_getInstance();
              }
              return Unit_getInstance();
            } else {
              return Unit_getInstance();
            }
          }
        }
      }
      Unit_getInstance();
    }
  };
  JobSupport.prototype._get_onCancelComplete__560530297_99q3y1_k$ = function () {
    return false;
  };
  JobSupport.prototype.cancellationExceptionMessage_a64063_k$ = function () {
    return 'Job was cancelled';
  };
  JobSupport.prototype.parentCancelled_53w4ri_k$ = function (parentJob) {
    this.cancelImpl_5ls1mt_k$(parentJob);
    Unit_getInstance();
  };
  JobSupport.prototype.childCancelled_fdoq8t_k$ = function (cause) {
    if (cause instanceof CancellationException)
      return true;
    else {
    }
    return this.cancelImpl_5ls1mt_k$(cause) ? this._get_handlesException__2187079175_yuzcvt_k$() : false;
  };
  JobSupport.prototype.cancelImpl_5ls1mt_k$ = function (cause) {
    var finalState = _get_COMPLETING_ALREADY__1904323772();
    if (this._get_onCancelComplete__560530297_99q3y1_k$()) {
      finalState = cancelMakeCompleting(this, cause);
      if (finalState === _get_COMPLETING_WAITING_CHILDREN__621847959())
        return true;
    }
    if (finalState === _get_COMPLETING_ALREADY__1904323772()) {
      finalState = makeCancelling(this, cause);
    }
    var tmp;
    if (finalState === _get_COMPLETING_ALREADY__1904323772()) {
      tmp = true;
    } else if (finalState === _get_COMPLETING_WAITING_CHILDREN__621847959()) {
      tmp = true;
    } else if (finalState === _get_TOO_LATE_TO_CANCEL__2262851771()) {
      tmp = false;
    } else {
      this.afterCompletion_2ogq6g_k$(finalState);
      tmp = true;
    }
    return tmp;
  };
  JobSupport.prototype.getChildJobCancellationCause_wx9uoh_k$ = function () {
    var state = this._get_state__3614753120_b8zcm8_k$();
    var tmp0_subject = state;
    var tmp;
    if (tmp0_subject instanceof Finishing) {
      tmp = state._get_rootCause__1061504650_hjzq8a_k$();
    } else {
      if (tmp0_subject instanceof CompletedExceptionally) {
        tmp = state._get_cause__3139734664_j3sn7c_k$();
      } else {
        if (!(tmp0_subject == null) ? isInterface(tmp0_subject, Incomplete) : false) {
          var tmp0_error_0 = 'Cannot be cancelling child in this state: ' + toString(state);
          throw IllegalStateException_init_$Create$(toString_0(tmp0_error_0));
        } else {
          {
            tmp = null;
          }
        }
      }
    }
    var rootCause = tmp;
    var tmp1_elvis_lhs = rootCause instanceof CancellationException ? rootCause : null;
    return tmp1_elvis_lhs == null ? new JobCancellationException('Parent job is ' + stateString(this, state), rootCause, this) : tmp1_elvis_lhs;
  };
  JobSupport.prototype.makeCompletingOnce_b13xy2_k$ = function (proposedUpdate) {
    {
      while (true) {
        var tmp$ret$0;
        $l$block: {
          var tmp0__anonymous__1_2495602521 = this._get_state__3614753120_b8zcm8_k$();
          var finalState_2 = tryMakeCompleting(this, tmp0__anonymous__1_2495602521, proposedUpdate);
          if (finalState_2 === _get_COMPLETING_ALREADY__1904323772())
            throw IllegalStateException_init_$Create$_0('Job ' + this + ' is already complete or completing, ' + ('but is being completed with ' + toString(proposedUpdate)), _get_exceptionOrNull__671063032(proposedUpdate, this));
          else if (finalState_2 === _get_COMPLETING_RETRY__2730327532()) {
            tmp$ret$0 = Unit_getInstance();
            break $l$block;
          } else
            return finalState_2;
        }
      }
      Unit_getInstance();
    }
  };
  JobSupport.prototype.attachChild_ik9c8b_k$ = function (child) {
    var tmp$ret$1;
    $l$block_0: {
      var tmp0__get_asHandler__0_1201048388 = new ChildHandleNode(child);
      var tmp$ret$0;
      $l$block: {
        tmp$ret$0 = tmp0__get_asHandler__0_1201048388;
        break $l$block;
      }
      tmp$ret$1 = tmp$ret$0;
      break $l$block_0;
    }
    var tmp = this.invokeOnCompletion$default_7q548c_k$(true, false, tmp$ret$1, 2, null);
    return isInterface(tmp, ChildHandle) ? tmp : THROW_CCE();
  };
  JobSupport.prototype.handleOnCompletionException_o179kb_k$ = function (exception) {
    throw exception;
  };
  JobSupport.prototype.onCancelling_bxyn9n_k$ = function (cause) {
  };
  JobSupport.prototype._get_isScopedCoroutine__175864179_2wpdo3_k$ = function () {
    return false;
  };
  JobSupport.prototype._get_handlesException__2187079175_yuzcvt_k$ = function () {
    return true;
  };
  JobSupport.prototype.handleJobException_oc4gxk_k$ = function (exception) {
    return false;
  };
  JobSupport.prototype.onCompletionInternal_39c1g8_k$ = function (state) {
  };
  JobSupport.prototype.afterCompletion_2ogq6g_k$ = function (state) {
  };
  JobSupport.prototype.toString = function () {
    return this.toDebugString_v3moy1_k$() + '@' + _get_hexAddress__2831015762(this);
  };
  JobSupport.prototype.toDebugString_v3moy1_k$ = function () {
    return this.nameString_cd9e9w_k$() + '{' + stateString(this, this._get_state__3614753120_b8zcm8_k$()) + '}';
  };
  JobSupport.prototype.nameString_cd9e9w_k$ = function () {
    return _get_classSimpleName__3937513404(this);
  };
  JobSupport.prototype.getCompletionExceptionOrNull_snuvbb_k$ = function () {
    var state = this._get_state__3614753120_b8zcm8_k$();
    {
      {
      }
      if (!!(!(state == null) ? isInterface(state, Incomplete) : false)) {
        var tmp$ret$0;
        $l$block: {
          tmp$ret$0 = 'This job has not completed yet';
          break $l$block;
        }
        var message_1 = tmp$ret$0;
        throw IllegalStateException_init_$Create$(toString_0(message_1));
      } else {
      }
    }
    return _get_exceptionOrNull__671063032(state, this);
  };
  JobSupport.prototype.getCompletedInternal_26f4i6_k$ = function () {
    var state = this._get_state__3614753120_b8zcm8_k$();
    {
      {
      }
      if (!!(!(state == null) ? isInterface(state, Incomplete) : false)) {
        var tmp$ret$0;
        $l$block: {
          tmp$ret$0 = 'This job has not completed yet';
          break $l$block;
        }
        var message_1 = tmp$ret$0;
        throw IllegalStateException_init_$Create$(toString_0(message_1));
      } else {
      }
    }
    if (state instanceof CompletedExceptionally)
      throw state._get_cause__3139734664_j3sn7c_k$();
    else {
    }
    return unboxState(state);
  };
  JobSupport.$metadata$ = {
    simpleName: 'JobSupport',
    kind: 'class',
    interfaces: [Job, ChildJob, ParentJob, SelectClause0]
  };
  function boxIncomplete(_this__1828080292) {
    init_properties_JobSupport_kt_3188198472();
    var tmp;
    if (!(_this__1828080292 == null) ? isInterface(_this__1828080292, Incomplete) : false) {
      tmp = new IncompleteStateBox(_this__1828080292);
    } else {
      {
        tmp = _this__1828080292;
      }
    }
    return tmp;
  }
  function JobCancellingNode() {
    JobNode.call(this);
  }
  JobCancellingNode.$metadata$ = {
    simpleName: 'JobCancellingNode',
    kind: 'class',
    interfaces: []
  };
  function InactiveNodeList(list) {
    this.list_1 = list;
  }
  InactiveNodeList.prototype._get_list__802566509_d9tsa5_k$ = function () {
    return this.list_1;
  };
  InactiveNodeList.prototype._get_isActive__4035225851_4an5s5_k$ = function () {
    return false;
  };
  InactiveNodeList.prototype.toString = function () {
    return _get_DEBUG__2224823294() ? this.list_1.getString_xqex6i_k$('New') : anyToString(this);
  };
  InactiveNodeList.$metadata$ = {
    simpleName: 'InactiveNodeList',
    kind: 'class',
    interfaces: [Incomplete]
  };
  function ChildHandleNode(childJob) {
    JobCancellingNode.call(this);
    this.childJob_1 = childJob;
  }
  ChildHandleNode.prototype.invoke_7fb7sc_k$ = function (cause) {
    return this.childJob_1.parentCancelled_53w4ri_k$(this._get_job__857118836_e6b14k_k$());
  };
  ChildHandleNode.prototype.invoke = function (cause) {
    return this.invoke_7fb7sc_k$(cause);
  };
  ChildHandleNode.prototype.childCancelled_fdoq8t_k$ = function (cause) {
    return this._get_job__857118836_e6b14k_k$().childCancelled_fdoq8t_k$(cause);
  };
  ChildHandleNode.$metadata$ = {
    simpleName: 'ChildHandleNode',
    kind: 'class',
    interfaces: [ChildHandle]
  };
  function InvokeOnCancelling(handler) {
    JobCancellingNode.call(this);
    this.handler_1 = handler;
    this._invoked_1 = atomic$int$1(0);
  }
  InvokeOnCancelling.prototype.invoke_7fb7sc_k$ = function (cause) {
    if (this._invoked_1.atomicfu$compareAndSet(0, 1))
      this.handler_1(cause);
  };
  InvokeOnCancelling.prototype.invoke = function (cause) {
    return this.invoke_7fb7sc_k$(cause);
  };
  InvokeOnCancelling.$metadata$ = {
    simpleName: 'InvokeOnCancelling',
    kind: 'class',
    interfaces: []
  };
  function InvokeOnCompletion(handler) {
    JobNode.call(this);
    this.handler_1 = handler;
  }
  InvokeOnCompletion.prototype.invoke_7fb7sc_k$ = function (cause) {
    return this.handler_1(cause);
  };
  InvokeOnCompletion.prototype.invoke = function (cause) {
    return this.invoke_7fb7sc_k$(cause);
  };
  InvokeOnCompletion.$metadata$ = {
    simpleName: 'InvokeOnCompletion',
    kind: 'class',
    interfaces: []
  };
  function unboxState(_this__1828080292) {
    init_properties_JobSupport_kt_3188198472();
    var tmp0_safe_receiver = _this__1828080292 instanceof IncompleteStateBox ? _this__1828080292 : null;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.state_1;
    return tmp1_elvis_lhs == null ? _this__1828080292 : tmp1_elvis_lhs;
  }
  function IncompleteStateBox(state) {
    this.state_1 = state;
  }
  IncompleteStateBox.$metadata$ = {
    simpleName: 'IncompleteStateBox',
    kind: 'class',
    interfaces: []
  };
  var properties_initialized_JobSupport_kt_333787756;
  function init_properties_JobSupport_kt_3188198472() {
    if (!properties_initialized_JobSupport_kt_333787756) {
      properties_initialized_JobSupport_kt_333787756 = true;
      COMPLETING_ALREADY = new Symbol('COMPLETING_ALREADY');
      COMPLETING_WAITING_CHILDREN = new Symbol('COMPLETING_WAITING_CHILDREN');
      COMPLETING_RETRY = new Symbol('COMPLETING_RETRY');
      TOO_LATE_TO_CANCEL = new Symbol('TOO_LATE_TO_CANCEL');
      SEALED = new Symbol('SEALED');
      EMPTY_NEW = new Empty(false);
      EMPTY_ACTIVE = new Empty(true);
    }
  }
  function MainCoroutineDispatcher() {
    CoroutineDispatcher.call(this);
  }
  MainCoroutineDispatcher.prototype.toString = function () {
    var tmp0_elvis_lhs = this.toStringInternalImpl_hcqz93_k$();
    return tmp0_elvis_lhs == null ? _get_classSimpleName__3937513404(this) + '@' + _get_hexAddress__2831015762(this) : tmp0_elvis_lhs;
  };
  MainCoroutineDispatcher.prototype.toStringInternalImpl_hcqz93_k$ = function () {
    var main = Dispatchers_getInstance()._get_Main__773689234_csmufm_k$();
    if (this === main)
      return 'Dispatchers.Main';
    var tmp;
    try {
      tmp = main._get_immediate__3483316416_df8hts_k$();
    } catch ($p) {
      var tmp_0;
      if ($p instanceof UnsupportedOperationException) {
        tmp_0 = null;
      } else {
        {
          throw $p;
        }
      }
      tmp = tmp_0;
    }
    var immediate = tmp;
    if (this === immediate)
      return 'Dispatchers.Main.immediate';
    return null;
  };
  MainCoroutineDispatcher.$metadata$ = {
    simpleName: 'MainCoroutineDispatcher',
    kind: 'class',
    interfaces: []
  };
  function TimeoutCancellationException() {
  }
  TimeoutCancellationException.$metadata$ = {
    simpleName: 'TimeoutCancellationException',
    kind: 'class',
    interfaces: [CopyableThrowable]
  };
  function Unconfined() {
    Unconfined_instance = this;
    CoroutineDispatcher.call(this);
  }
  Unconfined.prototype.isDispatchNeeded_fmz9vn_k$ = function (context) {
    return false;
  };
  Unconfined.prototype.dispatch_o98ux7_k$ = function (context, block) {
    var yieldContext = context.get_1pi7hg_k$(Key_getInstance_3());
    if (!(yieldContext == null)) {
      yieldContext.dispatcherWasUnconfined_1 = true;
      return Unit_getInstance();
    }
    throw UnsupportedOperationException_init_$Create$('Dispatchers.Unconfined.dispatch function can only be used by the yield function. If you wrap Unconfined dispatcher in your code, make sure you properly delegate isDispatchNeeded and dispatch calls.');
  };
  Unconfined.prototype.toString = function () {
    return 'Dispatchers.Unconfined';
  };
  Unconfined.$metadata$ = {
    simpleName: 'Unconfined',
    kind: 'object',
    interfaces: []
  };
  var Unconfined_instance;
  function Unconfined_getInstance() {
    if (Unconfined_instance == null)
      new Unconfined();
    return Unconfined_instance;
  }
  function Key_3() {
    Key_instance_2 = this;
  }
  Key_3.$metadata$ = {
    simpleName: 'Key',
    kind: 'object',
    interfaces: [Key]
  };
  var Key_instance_2;
  function Key_getInstance_3() {
    if (Key_instance_2 == null)
      new Key_3();
    return Key_instance_2;
  }
  function ensureCapacity($this) {
    var currentSize = $this.elements_1.length;
    var newCapacity = currentSize << 1;
    var tmp$ret$0;
    $l$block: {
      tmp$ret$0 = fillArrayVal(Array(newCapacity), null);
      break $l$block;
    }
    var newElements = tmp$ret$0;
    var tmp$ret$1;
    $l$block_0: {
      var tmp0_copyInto_0 = $this.elements_1;
      var tmp1_copyInto_0 = $this.head_1;
      var tmp2_copyInto_0 = tmp0_copyInto_0.length;
      arrayCopy(tmp0_copyInto_0, newElements, 0, tmp1_copyInto_0, tmp2_copyInto_0);
      tmp$ret$1 = newElements;
      break $l$block_0;
    }
    Unit_getInstance();
    var tmp$ret$2;
    $l$block_1: {
      var tmp3_copyInto_0 = $this.elements_1;
      var tmp4_copyInto_0 = $this.elements_1.length - $this.head_1 | 0;
      var tmp5_copyInto_0 = $this.head_1;
      arrayCopy(tmp3_copyInto_0, newElements, tmp4_copyInto_0, 0, tmp5_copyInto_0);
      tmp$ret$2 = newElements;
      break $l$block_1;
    }
    Unit_getInstance();
    $this.elements_1 = newElements;
    $this.head_1 = 0;
    $this.tail_1 = currentSize;
  }
  function ArrayQueue() {
    var tmp = this;
    var tmp$ret$0;
    $l$block: {
      tmp$ret$0 = fillArrayVal(Array(16), null);
      break $l$block;
    }
    tmp.elements_1 = tmp$ret$0;
    this.head_1 = 0;
    this.tail_1 = 0;
  }
  ArrayQueue.prototype._get_isEmpty__1500737838_oti0q6_k$ = function () {
    return this.head_1 === this.tail_1;
  };
  ArrayQueue.prototype.addLast_xhfl3v_k$ = function (element) {
    this.elements_1[this.tail_1] = element;
    this.tail_1 = (this.tail_1 + 1 | 0) & (this.elements_1.length - 1 | 0);
    if (this.tail_1 === this.head_1)
      ensureCapacity(this);
  };
  ArrayQueue.prototype.removeFirstOrNull_eges3a_k$ = function () {
    if (this.head_1 === this.tail_1)
      return null;
    var element = this.elements_1[this.head_1];
    this.elements_1[this.head_1] = null;
    this.head_1 = (this.head_1 + 1 | 0) & (this.elements_1.length - 1 | 0);
    return isObject(element) ? element : THROW_CCE();
  };
  ArrayQueue.$metadata$ = {
    simpleName: 'ArrayQueue',
    kind: 'class',
    interfaces: []
  };
  function OpDescriptor() {
  }
  OpDescriptor.$metadata$ = {
    simpleName: 'OpDescriptor',
    kind: 'class',
    interfaces: []
  };
  function _get_UNDEFINED__1354999585() {
    init_properties_DispatchedContinuation_kt_2588858602();
    return UNDEFINED;
  }
  var UNDEFINED;
  function _get_REUSABLE_CLAIMED__1637142852() {
    init_properties_DispatchedContinuation_kt_2588858602();
    return REUSABLE_CLAIMED;
  }
  var REUSABLE_CLAIMED;
  function resumeCancellableWith(_this__1828080292, result, onCancellation) {
    init_properties_DispatchedContinuation_kt_2588858602();
    var tmp0_subject = _this__1828080292;
    var tmp;
    if (tmp0_subject instanceof DispatchedContinuation) {
      var tmp1_resumeCancellableWith_0 = _this__1828080292;
      var state_1 = toState(result, onCancellation);
      var tmp_0;
      if (tmp1_resumeCancellableWith_0.dispatcher_1.isDispatchNeeded_fmz9vn_k$(tmp1_resumeCancellableWith_0._get_context__1558698818_ps0bpe_k$())) {
        tmp1_resumeCancellableWith_0._state_1 = state_1;
        tmp1_resumeCancellableWith_0._set_resumeMode__3223626279_v0m0nr_k$(_get_MODE_CANCELLABLE__581347323());
        tmp_0 = tmp1_resumeCancellableWith_0.dispatcher_1.dispatch_o98ux7_k$(tmp1_resumeCancellableWith_0._get_context__1558698818_ps0bpe_k$(), tmp1_resumeCancellableWith_0);
      } else {
        var tmp$ret$0;
        $l$block_5: {
          var tmp0_executeUnconfined_0 = _get_MODE_CANCELLABLE__581347323();
          {
          }
          var eventLoop_2 = ThreadLocalEventLoop_getInstance()._get_eventLoop__3953864115_5n30wd_k$();
          if (false ? eventLoop_2._get_isUnconfinedQueueEmpty__1719770308_sfwn9g_k$() : false) {
            tmp$ret$0 = false;
            break $l$block_5;
          }
          var tmp_1;
          if (eventLoop_2._get_isUnconfinedLoopActive__1254651510_kqzjau_k$()) {
            tmp1_resumeCancellableWith_0._state_1 = state_1;
            tmp1_resumeCancellableWith_0._set_resumeMode__3223626279_v0m0nr_k$(tmp0_executeUnconfined_0);
            eventLoop_2.dispatchUnconfined_do6j6f_k$(tmp1_resumeCancellableWith_0);
            tmp_1 = true;
          } else {
            {
              eventLoop_2.incrementUseCount_ocukpa_k$(true);
              try {
                {
                  var tmp$ret$3;
                  $l$block_3: {
                    var job_1_4 = tmp1_resumeCancellableWith_0._get_context__1558698818_ps0bpe_k$().get_1pi7hg_k$(Key_getInstance_2());
                    if (!(job_1_4 == null) ? !job_1_4._get_isActive__4035225851_4an5s5_k$() : false) {
                      var cause_2_5 = job_1_4.getCancellationException_8i1q6u_k$();
                      tmp1_resumeCancellableWith_0.cancelCompletedResult_tweln2_k$(state_1, cause_2_5);
                      var tmp$ret$2;
                      $l$block_1: {
                        var tmp$ret$1;
                        $l$block_0: {
                          var tmp0_failure_0_1_6 = Companion_getInstance();
                          tmp$ret$1 = _Result___init__impl__2241242780(createFailure(cause_2_5));
                          break $l$block_0;
                        }
                        tmp$ret$2 = tmp1_resumeCancellableWith_0.resumeWith_s3a3yh_k$(tmp$ret$1);
                        break $l$block_1;
                      }
                      tmp$ret$3 = true;
                      break $l$block_3;
                    }
                    tmp$ret$3 = false;
                    break $l$block_3;
                  }
                  if (!tmp$ret$3) {
                    {
                      var tmp$ret$4;
                      $l$block_4: {
                        var tmp0_withContinuationContext_0_7 = tmp1_resumeCancellableWith_0.continuation_1;
                        var tmp1_withContinuationContext_0_8 = tmp1_resumeCancellableWith_0.countOrElement_1;
                        tmp$ret$4 = tmp1_resumeCancellableWith_0.continuation_1.resumeWith_s3a3yh_k$(result);
                        break $l$block_4;
                      }
                    }
                  } else {
                  }
                }
                $l$loop: while (true) {
                  if (!eventLoop_2.processUnconfinedEvent_mypjl6_k$())
                    break $l$loop;
                }
              } catch ($p) {
                if ($p instanceof Error) {
                  tmp1_resumeCancellableWith_0.handleFatalException_56zdfo_k$($p, null);
                } else {
                  {
                    throw $p;
                  }
                }
              }
              finally {
                eventLoop_2.decrementUseCount_saho26_k$(true);
              }
            }
            tmp_1 = false;
          }
          tmp$ret$0 = tmp_1;
          break $l$block_5;
        }
        tmp_0 = Unit_getInstance();
      }
      tmp = tmp_0;
    } else {
      {
        tmp = _this__1828080292.resumeWith_s3a3yh_k$(result);
      }
    }
    return tmp;
  }
  function resumeCancellableWith$default(_this__1828080292, result, onCancellation, $mask0, $handler) {
    if (!(($mask0 & 2) === 0))
      onCancellation = null;
    return resumeCancellableWith(_this__1828080292, result, onCancellation);
  }
  function _get_reusableCancellableContinuation__588561561($this) {
    var tmp = $this._reusableCancellableContinuation_1._get_value__3683422336_a43j40_k$();
    return tmp instanceof CancellableContinuationImpl ? tmp : null;
  }
  function DispatchedContinuation(dispatcher, continuation) {
    DispatchedTask.call(this, _get_MODE_UNINITIALIZED__2647465612());
    this.dispatcher_1 = dispatcher;
    this.continuation_1 = continuation;
    this._state_1 = _get_UNDEFINED__1354999585();
    this.countOrElement_1 = threadContextElements(this._get_context__1558698818_ps0bpe_k$());
    this._reusableCancellableContinuation_1 = atomic$ref$1(null);
  }
  DispatchedContinuation.prototype._get_continuation__2061681140_y3gzck_k$ = function () {
    return this.continuation_1;
  };
  DispatchedContinuation.prototype._get_context__1558698818_ps0bpe_k$ = function () {
    return this.continuation_1._get_context__1558698818_ps0bpe_k$();
  };
  DispatchedContinuation.prototype._get_countOrElement__2919327745_mr0q9r_k$ = function () {
    return this.countOrElement_1;
  };
  DispatchedContinuation.prototype.awaitReusability_itz0u_k$ = function () {
    {
      var tmp0_loop_0 = this._reusableCancellableContinuation_1;
      while (true) {
        {
          var tmp1__anonymous__1_4003154330 = tmp0_loop_0._get_value__3683422336_a43j40_k$();
          if (!(tmp1__anonymous__1_4003154330 === _get_REUSABLE_CLAIMED__1637142852()))
            return Unit_getInstance();
        }
      }
      Unit_getInstance();
    }
  };
  DispatchedContinuation.prototype.release_wtm6d2_k$ = function () {
    this.awaitReusability_itz0u_k$();
    var tmp0_safe_receiver = _get_reusableCancellableContinuation__588561561(this);
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.detachChild_qdtbew_k$();
      Unit_getInstance();
    }
    Unit_getInstance();
  };
  DispatchedContinuation.prototype.takeState_olvzuy_k$ = function () {
    var state = this._state_1;
    {
    }
    this._state_1 = _get_UNDEFINED__1354999585();
    return state;
  };
  DispatchedContinuation.prototype._get_delegate__1111020262_idh0py_k$ = function () {
    return this;
  };
  DispatchedContinuation.prototype.resumeWith_s3a3yh_k$ = function (result) {
    var context = this.continuation_1._get_context__1558698818_ps0bpe_k$();
    var state = toState$default(result, null, 1, null);
    if (this.dispatcher_1.isDispatchNeeded_fmz9vn_k$(context)) {
      this._state_1 = state;
      this._set_resumeMode__3223626279_v0m0nr_k$(_get_MODE_ATOMIC__241678890());
      this.dispatcher_1.dispatch_o98ux7_k$(context, this);
    } else {
      var tmp$ret$0;
      $l$block_1: {
        var tmp0_executeUnconfined_0 = _get_MODE_ATOMIC__241678890();
        {
        }
        var eventLoop_2 = ThreadLocalEventLoop_getInstance()._get_eventLoop__3953864115_5n30wd_k$();
        if (false ? eventLoop_2._get_isUnconfinedQueueEmpty__1719770308_sfwn9g_k$() : false) {
          tmp$ret$0 = false;
          break $l$block_1;
        }
        var tmp;
        if (eventLoop_2._get_isUnconfinedLoopActive__1254651510_kqzjau_k$()) {
          this._state_1 = state;
          this._set_resumeMode__3223626279_v0m0nr_k$(tmp0_executeUnconfined_0);
          eventLoop_2.dispatchUnconfined_do6j6f_k$(this);
          tmp = true;
        } else {
          {
            eventLoop_2.incrementUseCount_ocukpa_k$(true);
            try {
              {
                var tmp$ret$1;
                $l$block_0: {
                  var tmp0_withCoroutineContext_0_4 = this._get_context__1558698818_ps0bpe_k$();
                  var tmp1_withCoroutineContext_0_5 = this.countOrElement_1;
                  tmp$ret$1 = this.continuation_1.resumeWith_s3a3yh_k$(result);
                  break $l$block_0;
                }
              }
              $l$loop: while (true) {
                if (!eventLoop_2.processUnconfinedEvent_mypjl6_k$())
                  break $l$loop;
              }
            } catch ($p) {
              if ($p instanceof Error) {
                this.handleFatalException_56zdfo_k$($p, null);
              } else {
                {
                  throw $p;
                }
              }
            }
            finally {
              eventLoop_2.decrementUseCount_saho26_k$(true);
            }
          }
          tmp = false;
        }
        tmp$ret$0 = tmp;
        break $l$block_1;
      }
      Unit_getInstance();
    }
  };
  DispatchedContinuation.prototype.cancelCompletedResult_tweln2_k$ = function (takenState, cause) {
    if (takenState instanceof CompletedWithCancellation) {
      takenState._get_onCancellation__3868581321_71uxiv_k$()(cause);
    } else {
    }
  };
  DispatchedContinuation.prototype.toString = function () {
    return 'DispatchedContinuation[' + this.dispatcher_1 + ', ' + toDebugString(this.continuation_1) + ']';
  };
  DispatchedContinuation.$metadata$ = {
    simpleName: 'DispatchedContinuation',
    kind: 'class',
    interfaces: [CoroutineStackFrame, Continuation]
  };
  var properties_initialized_DispatchedContinuation_kt_168814862;
  function init_properties_DispatchedContinuation_kt_2588858602() {
    if (!properties_initialized_DispatchedContinuation_kt_168814862) {
      properties_initialized_DispatchedContinuation_kt_168814862 = true;
      UNDEFINED = new Symbol('UNDEFINED');
      REUSABLE_CLAIMED = new Symbol('REUSABLE_CLAIMED');
    }
  }
  function _get_MODE_CANCELLABLE__581347323() {
    return MODE_CANCELLABLE;
  }
  var MODE_CANCELLABLE;
  function DispatchedTask(resumeMode) {
    SchedulerTask.call(this);
    this.resumeMode_1 = resumeMode;
  }
  DispatchedTask.prototype._set_resumeMode__3223626279_v0m0nr_k$ = function (_set____804775014) {
    this.resumeMode_1 = _set____804775014;
  };
  DispatchedTask.prototype.cancelCompletedResult_tweln2_k$ = function (takenState, cause) {
  };
  DispatchedTask.prototype.getSuccessfulResult_gdkv2w_k$ = function (state) {
    return (state == null ? true : isObject(state)) ? state : THROW_CCE();
  };
  DispatchedTask.prototype.getExceptionalResult_bnge6_k$ = function (state) {
    var tmp0_safe_receiver = state instanceof CompletedExceptionally ? state : null;
    return tmp0_safe_receiver == null ? null : tmp0_safe_receiver._get_cause__3139734664_j3sn7c_k$();
  };
  DispatchedTask.prototype.run_mw4iiu_k$ = function () {
    {
    }
    var taskContext = _get_taskContext__3781262951(this);
    var fatalException = null;
    try {
      var tmp = this._get_delegate__1111020262_idh0py_k$();
      var delegate = tmp instanceof DispatchedContinuation ? tmp : THROW_CCE();
      var continuation = delegate._get_continuation__2061681140_y3gzck_k$();
      var tmp$ret$5;
      $l$block_4: {
        var tmp0_withContinuationContext_0 = delegate._get_countOrElement__2919327745_mr0q9r_k$();
        var context_2 = continuation._get_context__1558698818_ps0bpe_k$();
        var state_3 = this.takeState_olvzuy_k$();
        var exception_4 = this.getExceptionalResult_bnge6_k$(state_3);
        var job_5 = (exception_4 == null ? _get_isCancellableMode__2954248492(this.resumeMode_1) : false) ? context_2.get_1pi7hg_k$(Key_getInstance_2()) : null;
        var tmp_0;
        if (!(job_5 == null) ? !job_5._get_isActive__4035225851_4an5s5_k$() : false) {
          var cause_6 = job_5.getCancellationException_8i1q6u_k$();
          this.cancelCompletedResult_tweln2_k$(state_3, cause_6);
          var tmp$ret$0;
          $l$block: {
            var tmp0_failure_0_7 = Companion_getInstance();
            var tmp1_failure_0_8 = recoverStackTrace(cause_6, continuation);
            tmp$ret$0 = _Result___init__impl__2241242780(createFailure(tmp1_failure_0_8));
            break $l$block;
          }
          tmp_0 = continuation.resumeWith_s3a3yh_k$(tmp$ret$0);
        } else {
          var tmp_1;
          if (!(exception_4 == null)) {
            var tmp$ret$2;
            $l$block_1: {
              var tmp$ret$1;
              $l$block_0: {
                var tmp0_failure_0_1_9 = Companion_getInstance();
                tmp$ret$1 = _Result___init__impl__2241242780(createFailure(exception_4));
                break $l$block_0;
              }
              tmp$ret$2 = continuation.resumeWith_s3a3yh_k$(tmp$ret$1);
              break $l$block_1;
            }
            tmp_1 = tmp$ret$2;
          } else {
            var tmp$ret$4;
            $l$block_3: {
              var tmp2_resume_0_10 = this.getSuccessfulResult_gdkv2w_k$(state_3);
              var tmp$ret$3;
              $l$block_2: {
                var tmp0_success_0_1_11 = Companion_getInstance();
                tmp$ret$3 = _Result___init__impl__2241242780(tmp2_resume_0_10);
                break $l$block_2;
              }
              tmp$ret$4 = continuation.resumeWith_s3a3yh_k$(tmp$ret$3);
              break $l$block_3;
            }
            tmp_1 = tmp$ret$4;
          }
          tmp_0 = tmp_1;
        }
        tmp$ret$5 = tmp_0;
        break $l$block_4;
      }
    } catch ($p) {
      if ($p instanceof Error) {
        fatalException = $p;
      } else {
        {
          throw $p;
        }
      }
    }
    finally {
      var tmp$ret$8;
      $l$block_7: {
        var tmp_2;
        try {
          var tmp$ret$6;
          $l$block_5: {
            var tmp0_success_0_1 = Companion_getInstance();
            var tmp1_success_0_2 = Unit_getInstance();
            tmp$ret$6 = _Result___init__impl__2241242780(Unit_getInstance());
            break $l$block_5;
          }
          tmp_2 = tmp$ret$6;
        } catch ($p) {
          var tmp_3;
          if ($p instanceof Error) {
            var tmp$ret$7;
            $l$block_6: {
              var tmp2_failure_0_4 = Companion_getInstance();
              tmp$ret$7 = _Result___init__impl__2241242780(createFailure($p));
              break $l$block_6;
            }
            tmp_3 = tmp$ret$7;
          } else {
            {
              throw $p;
            }
          }
          tmp_2 = tmp_3;
        }
        tmp$ret$8 = tmp_2;
        break $l$block_7;
      }
      var result = tmp$ret$8;
      this.handleFatalException_56zdfo_k$(fatalException, Result__exceptionOrNull_impl_1523290257(result));
    }
  };
  DispatchedTask.prototype.handleFatalException_56zdfo_k$ = function (exception, finallyException) {
    if (exception === null ? finallyException === null : false)
      return Unit_getInstance();
    if (!(exception === null) ? !(finallyException === null) : false) {
      {
      }
    }
    var tmp0_elvis_lhs = exception;
    var cause = tmp0_elvis_lhs == null ? finallyException : tmp0_elvis_lhs;
    var reason = new CoroutinesInternalError('Fatal exception in coroutines machinery for ' + this + '. ' + "Please read KDoc to 'handleFatalException' method and report this incident to maintainers", ensureNotNull(cause));
    handleCoroutineException(this._get_delegate__1111020262_idh0py_k$()._get_context__1558698818_ps0bpe_k$(), reason);
  };
  DispatchedTask.$metadata$ = {
    simpleName: 'DispatchedTask',
    kind: 'class',
    interfaces: []
  };
  function _get_MODE_UNINITIALIZED__2647465612() {
    return MODE_UNINITIALIZED;
  }
  var MODE_UNINITIALIZED;
  function _get_isCancellableMode__2954248492(_this__1828080292) {
    return _this__1828080292 === 1 ? true : _this__1828080292 === 2;
  }
  function _get_MODE_ATOMIC__241678890() {
    return MODE_ATOMIC;
  }
  var MODE_ATOMIC;
  function Symbol(symbol) {
    this.symbol_1 = symbol;
  }
  Symbol.prototype.toString = function () {
    return '<' + this.symbol_1 + '>';
  };
  Symbol.$metadata$ = {
    simpleName: 'Symbol',
    kind: 'class',
    interfaces: []
  };
  function startCoroutineCancellable(_this__1828080292, receiver, completion, onCancellation) {
    var tmp;
    try {
      var tmp_0 = intercepted(createCoroutineUnintercepted(_this__1828080292, receiver, completion));
      var tmp$ret$0;
      $l$block: {
        var tmp0_success_0_3 = Companion_getInstance();
        tmp$ret$0 = _Result___init__impl__2241242780(Unit_getInstance());
        break $l$block;
      }
      tmp = resumeCancellableWith(tmp_0, tmp$ret$0, onCancellation);
    } catch ($p) {
      var tmp_1;
      if ($p instanceof Error) {
        tmp_1 = dispatcherFailure$accessor$glj1hg(completion, $p);
      } else {
        {
          throw $p;
        }
      }
      tmp = tmp_1;
    }
    return tmp;
  }
  function startCoroutineCancellable$default(_this__1828080292, receiver, completion, onCancellation, $mask0, $handler) {
    if (!(($mask0 & 4) === 0))
      onCancellation = null;
    return startCoroutineCancellable(_this__1828080292, receiver, completion, onCancellation);
  }
  function dispatcherFailure(completion, e) {
    var tmp$ret$0;
    $l$block: {
      var tmp0_failure_0 = Companion_getInstance();
      tmp$ret$0 = _Result___init__impl__2241242780(createFailure(e));
      break $l$block;
    }
    completion.resumeWith_s3a3yh_k$(tmp$ret$0);
    throw e;
  }
  function startCoroutineCancellable_0(_this__1828080292, fatalCompletion) {
    var tmp;
    try {
      var tmp_0 = intercepted(_this__1828080292);
      var tmp$ret$0;
      $l$block: {
        var tmp0_success_0_3 = Companion_getInstance();
        tmp$ret$0 = _Result___init__impl__2241242780(Unit_getInstance());
        break $l$block;
      }
      var tmp_1 = tmp$ret$0;
      tmp = resumeCancellableWith$default(tmp_0, tmp_1, null, 2, null);
    } catch ($p) {
      var tmp_2;
      if ($p instanceof Error) {
        tmp_2 = dispatcherFailure$accessor$glj1hg(fatalCompletion, $p);
      } else {
        {
          throw $p;
        }
      }
      tmp = tmp_2;
    }
    return tmp;
  }
  function dispatcherFailure$accessor$glj1hg(completion, e) {
    return dispatcherFailure(completion, e);
  }
  function startCoroutineUndispatched(_this__1828080292, receiver, completion) {
    var tmp$ret$8;
    $l$block_7: {
      var tmp$ret$0;
      $l$block: {
        tmp$ret$0 = completion;
        break $l$block;
      }
      var actualCompletion_1 = tmp$ret$0;
      var tmp;
      try {
        var tmp$ret$5;
        $l$block_4: {
          var tmp$ret$4;
          $l$block_3: {
            var tmp0_withCoroutineContext_0_8 = completion._get_context__1558698818_ps0bpe_k$();
            var tmp$ret$3;
            $l$block_2: {
              var tmp$ret$2;
              $l$block_1: {
                var tmp$ret$1;
                $l$block_0: {
                  tmp$ret$1 = _this__1828080292;
                  break $l$block_0;
                }
                var a_1_2_9 = tmp$ret$1;
                tmp$ret$2 = typeof a_1_2_9 === 'function' ? a_1_2_9(receiver, actualCompletion_1) : _this__1828080292.invoke_5zdxxo_k$(receiver, actualCompletion_1);
                break $l$block_1;
              }
              tmp$ret$3 = tmp$ret$2;
              break $l$block_2;
            }
            tmp$ret$4 = tmp$ret$3;
            break $l$block_3;
          }
          tmp$ret$5 = tmp$ret$4;
          break $l$block_4;
        }
        tmp = tmp$ret$5;
      } catch ($p) {
        var tmp_0;
        if ($p instanceof Error) {
          var tmp$ret$7;
          $l$block_6: {
            var tmp$ret$6;
            $l$block_5: {
              var tmp0_failure_0_1_4 = Companion_getInstance();
              tmp$ret$6 = _Result___init__impl__2241242780(createFailure($p));
              break $l$block_5;
            }
            tmp$ret$7 = actualCompletion_1.resumeWith_s3a3yh_k$(tmp$ret$6);
            break $l$block_6;
          }
          tmp$ret$8 = Unit_getInstance();
          break $l$block_7;
        } else {
          {
            throw $p;
          }
        }
        tmp = tmp_0;
      }
      var value_2 = tmp;
      if (!(value_2 === _get_COROUTINE_SUSPENDED__2870145053())) {
        var tmp$ret$10;
        $l$block_9: {
          var tmp0_resume_0_5 = (value_2 == null ? true : isObject(value_2)) ? value_2 : THROW_CCE();
          var tmp$ret$9;
          $l$block_8: {
            var tmp0_success_0_1_6 = Companion_getInstance();
            tmp$ret$9 = _Result___init__impl__2241242780(tmp0_resume_0_5);
            break $l$block_8;
          }
          tmp$ret$10 = actualCompletion_1.resumeWith_s3a3yh_k$(tmp$ret$9);
          break $l$block_9;
        }
      }
    }
  }
  function SelectClause0() {
  }
  SelectClause0.$metadata$ = {
    simpleName: 'SelectClause0',
    kind: 'interface',
    interfaces: []
  };
  function SelectClause1() {
  }
  SelectClause1.$metadata$ = {
    simpleName: 'SelectClause1',
    kind: 'interface',
    interfaces: []
  };
  function CompletionHandlerBase() {
    LinkedListNode.call(this);
  }
  CompletionHandlerBase.$metadata$ = {
    simpleName: 'CompletionHandlerBase',
    kind: 'class',
    interfaces: []
  };
  function invokeIt(_this__1828080292, cause) {
    var tmp0_subject = typeof _this__1828080292;
    if (tmp0_subject === 'function')
      _this__1828080292(cause);
    else {
      var tmp$ret$0;
      $l$block: {
        tmp$ret$0 = _this__1828080292;
        break $l$block;
      }
      tmp$ret$0.invoke(cause);
    }
  }
  function toDebugString(_this__1828080292) {
    return toString_0(_this__1828080292);
  }
  function createDefaultDispatcher() {
    var tmp;
    if (isJsdom()) {
      tmp = NodeDispatcher_getInstance();
    } else {
      var tmp_0;
      var tmp_1;
      if (!(typeof window === 'undefined')) {
        var tmp$ret$0;
        $l$block: {
          var tmp0_asDynamic_0 = window;
          tmp$ret$0 = tmp0_asDynamic_0;
          break $l$block;
        }
        tmp_1 = tmp$ret$0 != null;
      } else {
        tmp_1 = false;
      }
      if (tmp_1) {
        var tmp$ret$1;
        $l$block_0: {
          var tmp1_asDynamic_0 = window;
          tmp$ret$1 = tmp1_asDynamic_0;
          break $l$block_0;
        }
        tmp_0 = !(typeof tmp$ret$1.addEventListener === 'undefined');
      } else {
        {
          tmp_0 = false;
        }
      }
      if (tmp_0) {
        tmp = asCoroutineDispatcher(window);
      } else {
        if (typeof process === 'undefined' ? true : typeof process.nextTick === 'undefined') {
          tmp = SetTimeoutDispatcher_getInstance();
        } else {
          {
            tmp = NodeDispatcher_getInstance();
          }
        }
      }
    }
    return tmp;
  }
  function isJsdom() {
    return ((((!(typeof navigator === 'undefined') ? navigator != null : false) ? navigator.userAgent != null : false) ? !(typeof navigator.userAgent === 'undefined') : false) ? !(typeof navigator.userAgent.match === 'undefined') : false) ? navigator.userAgent.match('\\bjsdom\\b') : false;
  }
  function newCoroutineContext(_this__1828080292, context) {
    var combined = _this__1828080292._get_coroutineContext__2519429620_td3xn0_k$().plus_rgw9wi_k$(context);
    return (!(combined === Dispatchers_getInstance()._get_Default__2834936080_o59jao_k$()) ? combined.get_1pi7hg_k$(Key_getInstance()) == null : false) ? combined.plus_rgw9wi_k$(Dispatchers_getInstance()._get_Default__2834936080_o59jao_k$()) : combined;
  }
  function _get_coroutineName__3134708654(_this__1828080292) {
    return null;
  }
  function initializeDefaultExceptionHandlers() {
  }
  function handleCoroutineExceptionImpl(context, exception) {
    console.error(exception);
  }
  var counter;
  function _get_DEBUG__2224823294() {
    return DEBUG;
  }
  var DEBUG;
  function _get_classSimpleName__3937513404(_this__1828080292) {
    var tmp0_elvis_lhs = getKClassFromExpression(_this__1828080292)._get_simpleName__973554894_g3mnri_k$();
    return tmp0_elvis_lhs == null ? 'Unknown' : tmp0_elvis_lhs;
  }
  function _get_hexAddress__2831015762(_this__1828080292) {
    var tmp$ret$0;
    $l$block: {
      tmp$ret$0 = _this__1828080292;
      break $l$block;
    }
    var result = tmp$ret$0.__debug_counter;
    if (!(typeof result === 'number')) {
      counter = counter + 1 | 0;
      result = counter;
      var tmp$ret$1;
      $l$block_0: {
        tmp$ret$1 = _this__1828080292;
        break $l$block_0;
      }
      tmp$ret$1.__debug_counter = result;
    }
    return ((!(result == null) ? typeof result === 'number' : false) ? result : THROW_CCE()).toString();
  }
  function Dispatchers() {
    Dispatchers_instance = this;
    this.Default_1 = createDefaultDispatcher();
    this.Unconfined_1 = Unconfined_getInstance();
    this.mainDispatcher_1 = new JsMainDispatcher(this.Default_1, false);
    this.injectedMainDispatcher_1 = null;
  }
  Dispatchers.prototype._get_Default__2834936080_o59jao_k$ = function () {
    return this.Default_1;
  };
  Dispatchers.prototype._get_Main__773689234_csmufm_k$ = function () {
    var tmp0_elvis_lhs = this.injectedMainDispatcher_1;
    return tmp0_elvis_lhs == null ? this.mainDispatcher_1 : tmp0_elvis_lhs;
  };
  Dispatchers.$metadata$ = {
    simpleName: 'Dispatchers',
    kind: 'object',
    interfaces: []
  };
  var Dispatchers_instance;
  function Dispatchers_getInstance() {
    if (Dispatchers_instance == null)
      new Dispatchers();
    return Dispatchers_instance;
  }
  function JsMainDispatcher(delegate, invokeImmediately) {
    MainCoroutineDispatcher.call(this);
    this.delegate_1 = delegate;
    this.invokeImmediately_1 = invokeImmediately;
    this.immediate_1 = this.invokeImmediately_1 ? this : new JsMainDispatcher(this.delegate_1, true);
  }
  JsMainDispatcher.prototype._get_immediate__3483316416_df8hts_k$ = function () {
    return this.immediate_1;
  };
  JsMainDispatcher.prototype.isDispatchNeeded_fmz9vn_k$ = function (context) {
    return !this.invokeImmediately_1;
  };
  JsMainDispatcher.prototype.dispatch_o98ux7_k$ = function (context, block) {
    return this.delegate_1.dispatch_o98ux7_k$(context, block);
  };
  JsMainDispatcher.prototype.toString = function () {
    var tmp0_elvis_lhs = this.toStringInternalImpl_hcqz93_k$();
    return tmp0_elvis_lhs == null ? this.delegate_1.toString() : tmp0_elvis_lhs;
  };
  JsMainDispatcher.$metadata$ = {
    simpleName: 'JsMainDispatcher',
    kind: 'class',
    interfaces: []
  };
  function createEventLoop() {
    return new UnconfinedEventLoop();
  }
  function UnconfinedEventLoop() {
    EventLoop.call(this);
  }
  UnconfinedEventLoop.prototype.dispatch_o98ux7_k$ = function (context, block) {
    unsupported();
  };
  UnconfinedEventLoop.$metadata$ = {
    simpleName: 'UnconfinedEventLoop',
    kind: 'class',
    interfaces: []
  };
  function unsupported() {
    throw UnsupportedOperationException_init_$Create$('runBlocking event loop is not supported');
  }
  function JobCancellationException(message, cause, job) {
    CancellationException_init_$Init$(message, cause, this);
    this.job_1 = job;
    captureStack(this, JobCancellationException);
  }
  JobCancellationException.prototype.toString = function () {
    return CancellationException.prototype.toString.call(this) + '; job=' + this.job_1;
  };
  JobCancellationException.prototype.equals = function (other) {
    var tmp;
    if (other === this) {
      tmp = true;
    } else {
      var tmp_0;
      var tmp_1;
      var tmp_2;
      if (other instanceof JobCancellationException) {
        tmp_2 = other.message == this.message;
      } else {
        {
          tmp_2 = false;
        }
      }
      if (tmp_2) {
        tmp_1 = equals(other.job_1, this.job_1);
      } else {
        {
          tmp_1 = false;
        }
      }
      if (tmp_1) {
        tmp_0 = equals(other.cause, this.cause);
      } else {
        {
          tmp_0 = false;
        }
      }
      tmp = tmp_0;
    }
    return tmp;
  };
  JobCancellationException.prototype.hashCode = function () {
    var tmp = imul(imul(getStringHashCode(ensureNotNull(this.message)), 31) + hashCode(this.job_1) | 0, 31);
    var tmp0_safe_receiver = this.cause;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : hashCode(tmp0_safe_receiver);
    return tmp + (tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs) | 0;
  };
  JobCancellationException.$metadata$ = {
    simpleName: 'JobCancellationException',
    kind: 'class',
    interfaces: []
  };
  function NodeDispatcher() {
    NodeDispatcher_instance = this;
    SetTimeoutBasedDispatcher.call(this);
  }
  NodeDispatcher.prototype.scheduleQueueProcessing_nyddyc_k$ = function () {
    process.nextTick(this._get_messageQueue__2421032257_uzoxj3_k$().processQueue_1);
  };
  NodeDispatcher.$metadata$ = {
    simpleName: 'NodeDispatcher',
    kind: 'object',
    interfaces: []
  };
  var NodeDispatcher_instance;
  function NodeDispatcher_getInstance() {
    if (NodeDispatcher_instance == null)
      new NodeDispatcher();
    return NodeDispatcher_instance;
  }
  function SetTimeoutDispatcher() {
    SetTimeoutDispatcher_instance = this;
    SetTimeoutBasedDispatcher.call(this);
  }
  SetTimeoutDispatcher.prototype.scheduleQueueProcessing_nyddyc_k$ = function () {
    setTimeout(this._get_messageQueue__2421032257_uzoxj3_k$().processQueue_1, 0);
    Unit_getInstance();
  };
  SetTimeoutDispatcher.$metadata$ = {
    simpleName: 'SetTimeoutDispatcher',
    kind: 'object',
    interfaces: []
  };
  var SetTimeoutDispatcher_instance;
  function SetTimeoutDispatcher_getInstance() {
    if (SetTimeoutDispatcher_instance == null)
      new SetTimeoutDispatcher();
    return SetTimeoutDispatcher_instance;
  }
  function SetTimeoutBasedDispatcher$ScheduledMessageQueue$processQueue$lambda(this$0) {
    return function () {
      this$0.process_mza50i_k$();
      return Unit_getInstance();
    };
  }
  function ScheduledMessageQueue($outer) {
    this.$this_1 = $outer;
    MessageQueue.call(this);
    var tmp = this;
    tmp.processQueue_1 = SetTimeoutBasedDispatcher$ScheduledMessageQueue$processQueue$lambda(this);
  }
  ScheduledMessageQueue.prototype.schedule_o6nex2_k$ = function () {
    this.$this_1.scheduleQueueProcessing_nyddyc_k$();
  };
  ScheduledMessageQueue.prototype.reschedule_mh206x_k$ = function () {
    setTimeout(this.processQueue_1, 0);
    Unit_getInstance();
  };
  ScheduledMessageQueue.$metadata$ = {
    simpleName: 'ScheduledMessageQueue',
    kind: 'class',
    interfaces: []
  };
  function SetTimeoutBasedDispatcher() {
    CoroutineDispatcher.call(this);
    this.messageQueue_1 = new ScheduledMessageQueue(this);
  }
  SetTimeoutBasedDispatcher.prototype._get_messageQueue__2421032257_uzoxj3_k$ = function () {
    return this.messageQueue_1;
  };
  SetTimeoutBasedDispatcher.prototype.dispatch_o98ux7_k$ = function (context, block) {
    this.messageQueue_1.enqueue_w6uc33_k$(block);
  };
  SetTimeoutBasedDispatcher.$metadata$ = {
    simpleName: 'SetTimeoutBasedDispatcher',
    kind: 'class',
    interfaces: [Delay]
  };
  function MessageQueue() {
    ArrayQueue.call(this);
    this.yieldEvery_1 = 16;
    this.scheduled_1 = false;
  }
  MessageQueue.prototype.enqueue_w6uc33_k$ = function (element) {
    this.addLast_xhfl3v_k$(element);
    if (!this.scheduled_1) {
      this.scheduled_1 = true;
      this.schedule_o6nex2_k$();
    }
  };
  MessageQueue.prototype.process_mza50i_k$ = function () {
    try {
      {
        var tmp0_repeat_0 = this.yieldEvery_1;
        {
        }
        var inductionVariable = 0;
        if (inductionVariable < tmp0_repeat_0)
          do {
            var index_2 = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            {
              var tmp0_elvis_lhs_5 = this.removeFirstOrNull_eges3a_k$();
              var tmp;
              if (tmp0_elvis_lhs_5 == null) {
                return Unit_getInstance();
              } else {
                tmp = tmp0_elvis_lhs_5;
              }
              var element_4 = tmp;
              element_4.run_mw4iiu_k$();
            }
          }
           while (inductionVariable < tmp0_repeat_0);
      }
    }finally {
      if (this._get_isEmpty__1500737838_oti0q6_k$()) {
        this.scheduled_1 = false;
      } else {
        this.reschedule_mh206x_k$();
      }
    }
  };
  MessageQueue.$metadata$ = {
    simpleName: 'MessageQueue',
    kind: 'class',
    interfaces: []
  };
  function WindowDispatcher(window_0) {
    CoroutineDispatcher.call(this);
    this.window_1 = window_0;
    this.queue_1 = new WindowMessageQueue(this.window_1);
  }
  WindowDispatcher.prototype.dispatch_o98ux7_k$ = function (context, block) {
    return this.queue_1.enqueue_w6uc33_k$(block);
  };
  WindowDispatcher.$metadata$ = {
    simpleName: 'WindowDispatcher',
    kind: 'class',
    interfaces: [Delay]
  };
  function WindowMessageQueue$lambda(this$0) {
    return function (event) {
      var tmp;
      if (event.source == this$0.window_1 ? event.data == this$0.messageName_1 : false) {
        event.stopPropagation();
        tmp = this$0.process_mza50i_k$();
      }
      return Unit_getInstance();
    };
  }
  function WindowMessageQueue$schedule$lambda(this$0) {
    return function (it) {
      this$0.process_mza50i_k$();
      return Unit_getInstance();
    };
  }
  function WindowMessageQueue(window_0) {
    MessageQueue.call(this);
    this.window_1 = window_0;
    this.messageName_1 = 'dispatchCoroutine';
    this.window_1.addEventListener('message', WindowMessageQueue$lambda(this), true);
  }
  WindowMessageQueue.prototype.schedule_o6nex2_k$ = function () {
    var tmp = Promise.resolve(Unit_getInstance());
    tmp.then(WindowMessageQueue$schedule$lambda(this));
    Unit_getInstance();
  };
  WindowMessageQueue.prototype.reschedule_mh206x_k$ = function () {
    this.window_1.postMessage(this.messageName_1, '*');
  };
  WindowMessageQueue.$metadata$ = {
    simpleName: 'WindowMessageQueue',
    kind: 'class',
    interfaces: []
  };
  function promise(_this__1828080292, context, start, block) {
    return asPromise(async(_this__1828080292, context, start, block));
  }
  function promise$default(_this__1828080292, context, start, block, $mask0, $handler) {
    if (!(($mask0 & 1) === 0))
      context = EmptyCoroutineContext_getInstance();
    if (!(($mask0 & 2) === 0))
      start = CoroutineStart_DEFAULT_getInstance();
    return promise(_this__1828080292, context, start, block);
  }
  function asPromise(_this__1828080292) {
    var promise = new Promise(asPromise$lambda(_this__1828080292));
    var tmp$ret$0;
    $l$block: {
      tmp$ret$0 = promise;
      break $l$block;
    }
    tmp$ret$0.deferred = _this__1828080292;
    return promise;
  }
  function asPromise$lambda$lambda($this_asPromise, $reject, $resolve) {
    return function (it) {
      var e = $this_asPromise.getCompletionExceptionOrNull_snuvbb_k$();
      Unit_getInstance();
      var tmp;
      if (!(e == null)) {
        tmp = $reject(e);
      } else {
        tmp = $resolve($this_asPromise.getCompleted_nczk2z_k$());
      }
      return Unit_getInstance();
    };
  }
  function asPromise$lambda($this_asPromise) {
    return function (resolve, reject) {
      $this_asPromise.invokeOnCompletion_t2apld_k$(asPromise$lambda$lambda($this_asPromise, reject, resolve));
      Unit_getInstance();
      return Unit_getInstance();
    };
  }
  function Runnable() {
  }
  Runnable.$metadata$ = {
    simpleName: 'Runnable',
    kind: 'interface',
    interfaces: []
  };
  function SchedulerTask() {
  }
  SchedulerTask.$metadata$ = {
    simpleName: 'SchedulerTask',
    kind: 'class',
    interfaces: [Runnable]
  };
  function _get_taskContext__3781262951(_this__1828080292) {
    return Unit_getInstance();
  }
  function asCoroutineDispatcher(_this__1828080292) {
    var tmp$ret$0;
    $l$block: {
      tmp$ret$0 = _this__1828080292;
      break $l$block;
    }
    var tmp0_elvis_lhs = tmp$ret$0.coroutineDispatcher;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      var tmp$ret$2;
      $l$block_1: {
        var tmp0_also_0 = new WindowDispatcher(_this__1828080292);
        {
        }
        {
          var tmp$ret$1;
          $l$block_0: {
            tmp$ret$1 = _this__1828080292;
            break $l$block_0;
          }
          tmp$ret$1.coroutineDispatcher = tmp0_also_0;
        }
        tmp$ret$2 = tmp0_also_0;
        break $l$block_1;
      }
      tmp = tmp$ret$2;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  function identitySet(expectedSize) {
    return HashSet_init_$Create$(expectedSize);
  }
  function LinkedListHead() {
    LinkedListNode.call(this);
  }
  LinkedListHead.$metadata$ = {
    simpleName: 'LinkedListHead',
    kind: 'class',
    interfaces: []
  };
  function LinkedListNode() {
    this._next_1 = this;
    this._prev_1 = this;
    this._removed_1 = false;
  }
  LinkedListNode.prototype._get__next__3036752447_kt3wsh_k$ = function () {
    return this._next_1;
  };
  LinkedListNode.prototype._get__prev__3038968575_krsetd_k$ = function () {
    return this._prev_1;
  };
  LinkedListNode.prototype._get__removed__1059529930_hiteiy_k$ = function () {
    return this._removed_1;
  };
  LinkedListNode.prototype.addLast_uyctnf_k$ = function (node) {
    var prev = this._prev_1;
    node._next_1 = this;
    node._prev_1 = prev;
    prev._next_1 = node;
    this._prev_1 = node;
  };
  LinkedListNode.prototype.remove_fgfybg_k$ = function () {
    return this.removeImpl_i5v938_k$();
  };
  LinkedListNode.prototype.removeImpl_i5v938_k$ = function () {
    if (this._removed_1)
      return false;
    var prev = this._prev_1;
    var next = this._next_1;
    prev._next_1 = next;
    next._prev_1 = prev;
    this._removed_1 = true;
    return true;
  };
  LinkedListNode.prototype.addOneIfEmpty_cbgboi_k$ = function (node) {
    if (!(this._next_1 === this))
      return false;
    this.addLast_uyctnf_k$(node);
    return true;
  };
  LinkedListNode.$metadata$ = {
    simpleName: 'LinkedListNode',
    kind: 'class',
    interfaces: []
  };
  function unwrap(exception) {
    return exception;
  }
  function CoroutineStackFrame() {
  }
  CoroutineStackFrame.$metadata$ = {
    simpleName: 'CoroutineStackFrame',
    kind: 'interface',
    interfaces: []
  };
  function recoverStackTrace(exception, continuation) {
    return exception;
  }
  function threadContextElements(context) {
    return 0;
  }
  function CommonThreadLocal() {
    this.value_1 = null;
  }
  CommonThreadLocal.prototype.get_26vq_k$ = function () {
    var tmp = this.value_1;
    return (tmp == null ? true : isObject(tmp)) ? tmp : THROW_CCE();
  };
  CommonThreadLocal.prototype.set_hda1d2_k$ = function (value) {
    this.value_1 = value;
  };
  CommonThreadLocal.$metadata$ = {
    simpleName: 'CommonThreadLocal',
    kind: 'class',
    interfaces: []
  };
  //region block: post-declaration
  JobSupport.prototype.invokeOnCompletion$default_7q548c_k$ = invokeOnCompletion$default;
  JobSupport.prototype.plus_rgw9wi_k$ = plus;
  JobSupport.prototype.get_1pi7hg_k$ = get;
  JobSupport.prototype.fold_6dbyow_k$ = fold;
  JobSupport.prototype.minusKey_y21q55_k$ = minusKey;
  AbstractCoroutine.prototype.invokeOnCompletion$default_7q548c_k$ = invokeOnCompletion$default;
  AbstractCoroutine.prototype.plus_rgw9wi_k$ = plus;
  AbstractCoroutine.prototype.get_1pi7hg_k$ = get;
  AbstractCoroutine.prototype.fold_6dbyow_k$ = fold;
  AbstractCoroutine.prototype.minusKey_y21q55_k$ = minusKey;
  DeferredCoroutine.prototype.invokeOnCompletion$default_7q548c_k$ = invokeOnCompletion$default;
  DeferredCoroutine.prototype.plus_rgw9wi_k$ = plus;
  DeferredCoroutine.prototype.get_1pi7hg_k$ = get;
  DeferredCoroutine.prototype.fold_6dbyow_k$ = fold;
  DeferredCoroutine.prototype.minusKey_y21q55_k$ = minusKey;
  LazyDeferredCoroutine.prototype.invokeOnCompletion$default_7q548c_k$ = invokeOnCompletion$default;
  LazyDeferredCoroutine.prototype.plus_rgw9wi_k$ = plus;
  LazyDeferredCoroutine.prototype.get_1pi7hg_k$ = get;
  LazyDeferredCoroutine.prototype.fold_6dbyow_k$ = fold;
  LazyDeferredCoroutine.prototype.minusKey_y21q55_k$ = minusKey;
  CoroutineDispatcher.prototype.get_1pi7hg_k$ = get_0;
  CoroutineDispatcher.prototype.fold_6dbyow_k$ = fold;
  CoroutineDispatcher.prototype.minusKey_y21q55_k$ = minusKey_0;
  CoroutineDispatcher.prototype.plus_rgw9wi_k$ = plus;
  EventLoop.prototype.plus_rgw9wi_k$ = plus;
  EventLoop.prototype.get_1pi7hg_k$ = get_0;
  EventLoop.prototype.fold_6dbyow_k$ = fold;
  EventLoop.prototype.minusKey_y21q55_k$ = minusKey_0;
  MainCoroutineDispatcher.prototype.plus_rgw9wi_k$ = plus;
  MainCoroutineDispatcher.prototype.get_1pi7hg_k$ = get_0;
  MainCoroutineDispatcher.prototype.fold_6dbyow_k$ = fold;
  MainCoroutineDispatcher.prototype.minusKey_y21q55_k$ = minusKey_0;
  Unconfined.prototype.plus_rgw9wi_k$ = plus;
  Unconfined.prototype.get_1pi7hg_k$ = get_0;
  Unconfined.prototype.fold_6dbyow_k$ = fold;
  Unconfined.prototype.minusKey_y21q55_k$ = minusKey_0;
  JsMainDispatcher.prototype.plus_rgw9wi_k$ = plus;
  JsMainDispatcher.prototype.get_1pi7hg_k$ = get_0;
  JsMainDispatcher.prototype.fold_6dbyow_k$ = fold;
  JsMainDispatcher.prototype.minusKey_y21q55_k$ = minusKey_0;
  UnconfinedEventLoop.prototype.plus_rgw9wi_k$ = plus;
  UnconfinedEventLoop.prototype.get_1pi7hg_k$ = get_0;
  UnconfinedEventLoop.prototype.fold_6dbyow_k$ = fold;
  UnconfinedEventLoop.prototype.minusKey_y21q55_k$ = minusKey_0;
  SetTimeoutBasedDispatcher.prototype.plus_rgw9wi_k$ = plus;
  SetTimeoutBasedDispatcher.prototype.get_1pi7hg_k$ = get_0;
  SetTimeoutBasedDispatcher.prototype.fold_6dbyow_k$ = fold;
  SetTimeoutBasedDispatcher.prototype.minusKey_y21q55_k$ = minusKey_0;
  NodeDispatcher.prototype.plus_rgw9wi_k$ = plus;
  NodeDispatcher.prototype.get_1pi7hg_k$ = get_0;
  NodeDispatcher.prototype.fold_6dbyow_k$ = fold;
  NodeDispatcher.prototype.minusKey_y21q55_k$ = minusKey_0;
  SetTimeoutDispatcher.prototype.plus_rgw9wi_k$ = plus;
  SetTimeoutDispatcher.prototype.get_1pi7hg_k$ = get_0;
  SetTimeoutDispatcher.prototype.fold_6dbyow_k$ = fold;
  SetTimeoutDispatcher.prototype.minusKey_y21q55_k$ = minusKey_0;
  WindowDispatcher.prototype.plus_rgw9wi_k$ = plus;
  WindowDispatcher.prototype.get_1pi7hg_k$ = get_0;
  WindowDispatcher.prototype.fold_6dbyow_k$ = fold;
  WindowDispatcher.prototype.minusKey_y21q55_k$ = minusKey_0;
  //endregion
  //region block: init
  MODE_CANCELLABLE = 1;
  MODE_UNINITIALIZED = -1;
  MODE_ATOMIC = 0;
  counter = 0;
  DEBUG = false;
  //endregion
  //region block: exports
  _.$crossModule$ = _.$crossModule$ || {};
  _.$crossModule$.promise$default = promise$default;
  _.$crossModule$.GlobalScope_getInstance = GlobalScope_getInstance;
  _.$crossModule$.CoroutineScope = CoroutineScope;
  //endregion
  return _;
}));

//# sourceMappingURL=kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.js.map